/* eslint-disable */
import {
    EU_ONE_MB, EU_MAX_DATA_SIZE_MB, EU_LIBRARY_STACK_MB, EU_LIBRARY_MEMORY_MB, EU_MAX_P7S_CONTAINER_SIZE, EU_MAX_P7E_CONTAINER_SIZE, EU_DEFAULT_LANG, EU_UA_LANG, EU_RU_LANG, EU_EN_LANG, EU_SUBJECT_TYPE_UNDIFFERENCED, EU_SUBJECT_TYPE_CA, EU_SUBJECT_TYPE_CA_SERVER, EU_SUBJECT_TYPE_RA_ADMINISTRATOR, EU_SUBJECT_TYPE_END_USER, EU_SUBJECT_CA_SERVER_SUB_TYPE_UNDIFFERENCED, EU_SUBJECT_CA_SERVER_SUB_TYPE_CMP, EU_SUBJECT_CA_SERVER_SUB_TYPE_TSP, EU_SUBJECT_CA_SERVER_SUB_TYPE_OCSP, EU_CERT_KEY_TYPE_UNKNOWN, EU_CERT_KEY_TYPE_DSTU4145, EU_CERT_KEY_TYPE_RSA, EU_KEY_USAGE_UNKNOWN, EU_KEY_USAGE_DIGITAL_SIGNATURE, EU_KEY_USAGE_KEY_AGREEMENT, EU_RECIPIENT_APPEND_TYPE_BY_ISSUER_SERIAL, EU_RECIPIENT_APPEND_TYPE_BY_KEY_ID, EU_RECIPIENT_INFO_TYPE_ISSUER_SERIAL, EU_RECIPIENT_INFO_TYPE_KEY_ID, EU_CTX_HASH_ALGO_UNKNOWN, EU_CTX_HASH_ALGO_GOST34311, EU_CTX_HASH_ALGO_SHA160, EU_CTX_HASH_ALGO_SHA224, EU_CTX_HASH_ALGO_SHA256, EU_CTX_SIGN_UNKNOWN, EU_CTX_SIGN_DSTU4145_WITH_GOST34311, EU_CTX_SIGN_RSA_WITH_SHA, EU_CCS_TYPE_REVOKE, EU_CCS_TYPE_HOLD, EU_REVOCATION_REASON_UNKNOWN, EU_REVOCATION_REASON_KEY_COMPROMISE, EU_REVOCATION_REASON_NEW_ISSUED, EU_ERROR_NONE, EU_ERROR_UNKNOWN, EU_ERROR_NOT_SUPPORTED, EU_ERROR_NOT_INITIALIZED, EU_ERROR_BAD_PARAMETER, EU_ERROR_LIBRARY_LOAD, EU_ERROR_READ_SETTINGS, EU_ERROR_TRANSMIT_REQUEST, EU_ERROR_MEMORY_ALLOCATION, EU_WARNING_END_OF_ENUM, EU_ERROR_PROXY_NOT_AUTHORIZED, EU_ERROR_NO_GUI_DIALOGS, EU_ERROR_DOWNLOAD_FILE, EU_ERROR_WRITE_SETTINGS, EU_ERROR_CANCELED_BY_GUI, EU_ERROR_OFFLINE_MODE, EU_ERROR_KEY_MEDIAS_FAILED, EU_ERROR_KEY_MEDIAS_ACCESS_FAILED, EU_ERROR_KEY_MEDIAS_READ_FAILED, EU_ERROR_KEY_MEDIAS_WRITE_FAILED, EU_WARNING_KEY_MEDIAS_READ_ONLY, EU_ERROR_KEY_MEDIAS_DELETE, EU_ERROR_KEY_MEDIAS_CLEAR, EU_ERROR_BAD_PRIVATE_KEY, EU_ERROR_PKI_FORMATS_FAILED, EU_ERROR_CSP_FAILED, EU_ERROR_BAD_SIGNATURE, EU_ERROR_AUTH_FAILED, EU_ERROR_NOT_RECEIVER, EU_ERROR_STORAGE_FAILED, EU_ERROR_BAD_CERT, EU_ERROR_CERT_NOT_FOUND, EU_ERROR_INVALID_CERT_TIME, EU_ERROR_CERT_IN_CRL, EU_ERROR_BAD_CRL, EU_ERROR_NO_VALID_CRLS, EU_ERROR_GET_TIME_STAMP, EU_ERROR_BAD_TSP_RESPONSE, EU_ERROR_TSP_SERVER_CERT_NOT_FOUND, EU_ERROR_TSP_SERVER_CERT_INVALID, EU_ERROR_GET_OCSP_STATUS, EU_ERROR_BAD_OCSP_RESPONSE, EU_ERROR_CERT_BAD_BY_OCSP, EU_ERROR_OCSP_SERVER_CERT_NOT_FOUND, EU_ERROR_OCSP_SERVER_CERT_INVALID, EU_ERROR_LDAP_ERROR, EU_ERROR_JS_ERRORS, EU_ERROR_JS_BROWSER_NOT_SUPPORTED, EU_ERROR_JS_LIBRARY_NOT_INITIALIZED, EU_ERROR_JS_LIBRARY_LOAD, EU_ERROR_JS_LIBRARY_ERROR, EU_ERROR_JS_OPEN_FILE, EU_ERROR_JS_READ_FILE, EU_ERROR_JS_WRITE_FILE, EU_SYSTEMTIME_SIZE, EU_CERT_OWNER_INFO_SIZE, EU_SIGN_INFO_SIZE, EU_SENDER_INFO_SIZE, EU_CRL_INFO_SIZE, EU_CERT_INFO_SIZE, EU_CRL_DETAILED_INFO_SIZE, EU_TIME_INFO_SIZE, EU_KEY_MEDIA_SIZE, EU_USER_INFO_SIZE, EU_PASS_MAX_LENGTH, EU_PATH_MAX_LENGTH, EU_COMMON_NAME_MAX_LENGTH, EU_LOCALITY_MAX_LENGTH, EU_STATE_MAX_LENGTH, EU_ORGANIZATION_MAX_LENGTH, EU_ORG_UNIT_MAX_LENGTH, EU_TITLE_MAX_LENGTH, EU_STREET_MAX_LENGTH, EU_PHONE_MAX_LENGTH, EU_SURNAME_MAX_LENGTH, EU_GIVENNAME_MAX_LENGTH, EU_EMAIL_MAX_LENGTH, EU_ADDRESS_MAX_LENGTH, EU_EDRPOU_MAX_LENGTH, EU_DRFO_MAX_LENGTH, EU_NBU_MAX_LENGTH, EU_SPFM_MAX_LENGTH, EU_O_CODE_MAX_LENGTH, EU_OU_CODE_MAX_LENGTH, EU_USER_CODE_MAX_LENGTH, EU_UPN_MAX_LENGTH, EU_KEYS_TYPE_NONE, EU_KEYS_TYPE_DSTU_AND_ECDH_WITH_GOST, EU_KEYS_TYPE_RSA_WITH_SHA, EU_KEYS_LENGTH_DS_UA_191, EU_KEYS_LENGTH_DS_UA_257, EU_KEYS_LENGTH_DS_UA_307, EU_KEYS_LENGTH_KEP_UA_257, EU_KEYS_LENGTH_KEP_UA_431, EU_KEYS_LENGTH_KEP_UA_571, EU_KEYS_LENGTH_DS_RSA_1024, EU_KEYS_LENGTH_DS_RSA_2048, EU_KEYS_LENGTH_DS_RSA_3072, EU_KEYS_LENGTH_DS_RSA_4096, EU_CONTENT_ENC_ALGO_TDES_CBC, EU_CONTENT_ENC_ALGO_AES_256_CBC, EU_HEADER_CA_TYPE, EU_HEADER_PART_TYPE_SIGNED, EU_HEADER_PART_TYPE_ENCRYPTED, EU_HEADER_PART_TYPE_STAMPED, EU_HEADER_PART_TYPE_CERTCRYPT, EU_HEADER_MAX_CA_TYPE_SIZE, EU_KEY_ID_ACCOUNTANT, EU_KEY_ID_DIRECTOR, EU_KEY_ID_STAMP, EU_RESOLVE_OIDS_PARAMETER, EU_MAKE_PKEY_PFX_CONTAINER_PARAMETER, UA_OID_EXT_KEY_USAGE_STAMP, EU_CHECK_PRIVATE_KEY_CONTEXT_PARAMETER, EU_RESOLVE_OIDS_CONTEXT_PARAMETER, EU_EXPORATABLE_CONTEXT_CONTEXT_PARAMETER, CP1251Table, UTF8Table, EU_ERRORS_STRINGS, EU_ERRORS_STRINGS_UA, EU_ERRORS_STRINGS_RU, EU_ERRORS_STRINGS_EN, MakeClass, NewClass, EndUserFileFields, EndUserFile, EndUserOwnerInfoFields, EndUserOwnerInfo, EndUserTimeInfoFields, EndUserTimeInfo, EndUserSignInfoFields, EndUserSignInfo, EndUserSenderInfoFields, EndUserSenderInfo, EndUserCertificateInfoFields, EndUserCertificateInfo, EndUserCertificateInfoExFields, EndUserCertificateInfoEx, EndUserFileStoreSettings, EndUserProxySettings, EndUserTSPSettings, EndUserOCSPSettings, EndUserCMPSettings, EndUserLDAPSettings, EndUserModeSettings, EndUserOCSPAccessInfoModeSettings, EndUserOCSPAccessInfoSettings, EndUserInfo, EndUserPrivateKey, EndUserContext, EndUserPrivateKeyContextFields, EndUserPrivateKeyContext, EndUserPrivateKeyInfo, EndUserHashContext, EndUserCertificateFields, EndUserCertificate, EndUserSenderInfoEx, EndUserRecipientInfo, EndUserSessionFields, EndUserSession, EndUserTransportHeaderFields, EndUserTransportHeader, EndUserCryptoHeader, EndUserJKSPrivateKey,
    StringToCString, StringToArray, ArrayToString, UTF8ToCP1251Array, CP1251PointerToUTF8, StringToUTF16LEArray, UTF16LEArrayToString, StringEncoder, SetClassID, intArrayFromStrings, SystemTimeToDate, DateToSystemTime, IsStructureFilled, ClassSetDefaultValues, StructureToClass, GetTransferableObject, TransferableObjectToClass
} from './euscpt'
//=============================================================================

export var EU_PTR_SIZE				= 4;
export var EU_INT_SIZE				= 4;
export var EU_DWORD_SIZE			= 4;
export var EU_BOOL_SIZE			= 4;

export var EU_TRUE 				= 1;
export var EU_FALSE 				= 0;

//=============================================================================

//SD - should be global - used by Module!!! Moved to euscp.js
// var XMLHTTPProxyService = "";
// var XMLHTTPDirectAccess = false;
// var XMLHTTPDirectAccessAddresses = [];

//=============================================================================

function EUSignCPException(errorCode, message, messageEx) {
	this.errorCode = errorCode;
	this.message = message;
	this.messageEx = messageEx || '';
	
	this.toString = function() {
		return this.message + "(" + errorCode + ")";
	};
	
	this.GetErrorCode = function() {
		return this.errorCode;
	};
	
	this.GetMessage = function() {
		return this.message;
	};
	
	this.toStringEx = function() {
		return this.toString() + 
			((this.messageEx != '') ? 
				". " + this.messageEx : '');
	};
	
	this.GetMessageEx = function() {
		return this.messageEx;
	};
}

//=============================================================================

function EUPointerConstructor(size, isArray, moduleFreeFunc, context) {
	this.ptr = Module._malloc(size);
	Module.setValue(this.ptr, 0);

	this.isArray = isArray;
	if (isArray) {
		this.lengthPtr = Module._malloc(EU_PTR_SIZE);
		Module.setValue(this.lengthPtr, 0);
	} else {
		this.lengthPtr = 0;
	}

	this.moduleFreeFunc = moduleFreeFunc;
	this.context = context;

	this.toPtr = function() {
		var pPtr = 0;
		try {
			pPtr = Module.getValue(this.ptr, "i8*");
		} catch(e) {
			this.raiseError(e);
		}

		this.free();

		return pPtr;
	};
	this.toNumber = function() {
		var number = null;
		try {
			number = Module.getValue(this.ptr, "i32");
		} catch(e) {
			this.raiseError(e);
		}

		this.free();

		return number;
	};
	this.toBoolean = function() {
		return (this.toNumber() != EU_FALSE);
	};
	this.toString = function(checkEmpty) {
		var string = null;
		try {
			var strPtr = this.toPtr();
			if (strPtr | 0) {
				string = CP1251PointerToUTF8(strPtr);
				if (context != null)
					Module._EUCtxFreeMemory(context|0, strPtr);
				else
					Module._EUFreeMemory(strPtr);
			}
			
			if (checkEmpty) {
				if (string == "")
					throw "Decoded string is empty";
			}
		} catch(e) {
			this.raiseError(e);
		}

		this.free();

		return string;
	};
	this.toStringArray = function() {
		var strings = null;
		try {
			var strPtr = this.toPtr();
			if (strPtr | 0) {
				strings = [];
				while (1) {
					var str = CP1251PointerToUTF8(strPtr);
					strings.push(str);
					if (HEAPU8[((strPtr + str.length + 1)|0)] == 0)
						break;
					strPtr = ((strPtr + str.length + 1)|0);
				}

				if (context != null)
					Module._EUCtxFreeMemory(context|0, strPtr);
				else
					Module._EUFreeMemory(strPtr);
			}
		} catch(e) {
			this.raiseError(e);
		}

		this.free();

		return strings;
	};
	this.toArray = function() {
		var array = null;
		try {
			var arrPtr = Module.getValue(this.ptr, "i8*");
			var arrLength = Module.getValue(this.lengthPtr, "i32");
			var arrBuffer = new ArrayBuffer(arrLength);

			array = new Uint8Array(arrBuffer);
			array.set(new Uint8Array(Module.HEAPU8.buffer, arrPtr, arrLength));

			if (context != null)
				Module._EUCtxFreeMemory(context|0, arrPtr|0);
			else
				Module._EUFreeMemory(arrPtr|0);
		} catch(e) {
			this.raiseError(e);
		}

		this.free();

		return array;
	};
	this.toArrayOfByteArrays = function(count) {
		if (count == 0)
			return [];
		
		var array = [];
		try {
			var arraysPtr = Module.getValue(this.ptr, "i32*");
			var arraysLengthsPtr = Module.getValue(this.lengthPtr, "i32");
			
			for (var i = 0; i < count; i++) {
				var pCurPtr = (arraysPtr + i * EU_PTR_SIZE) | 0;
				var arrPtr = Module.getValue(pCurPtr, "i8*");
				var arrLength = Module.getValue(
					arraysLengthsPtr + i * EU_INT_SIZE, "i32*");

				var arrBuffer = new ArrayBuffer(arrLength);

				var tmpArr = new Uint8Array(arrBuffer);
				tmpArr.set(new Uint8Array(Module.HEAPU8.buffer, arrPtr, arrLength));
				array.push(tmpArr);
			}

			Module._EUFreeCertificatesArray(
				count, arraysPtr, arraysLengthsPtr);
		} catch(e) {
			this.raiseError(e);
		}

		this.free();

		return array;
	};
	this.free = function() {
		try {
			if (this.moduleFreeFunc != null)
				this.moduleFreeFunc(this);

			if (this.ptr != 0)
				Module._free(this.ptr);
			if (this.lengthPtr != 0)
				Module._free(this.lengthPtr);
		} catch (e) {}

		this.ptr = 0;
		this.lengthPtr = 0;
		this.moduleFreeFunc = null;
	};
	this.raiseError = function(msg) {
		var error = EU_ERROR_JS_LIBRARY_ERROR;
		var message = EU_ERRORS_STRINGS[Module.errorLangCode][error];

		this.free();

		throw new EUSignCPException(error, message, msg);
	};
}

function EUPointer(context) {
	if (context === undefined)
		context = null;

	return new EUPointerConstructor(EU_PTR_SIZE, false, null, context);
}

function EUPointerBool() {
	return new EUPointerConstructor(EU_BOOL_SIZE, false, null, null);
}

function EUPointerInt() {
	return new EUPointerConstructor(EU_INT_SIZE, false, null, null);
}

function EUPointerDWORD() {
	return new EUPointerConstructor(EU_DWORD_SIZE, false, null, null);
}

function EUPointerArray(context) {
	if (context === undefined)
		context = null;

	return new EUPointerConstructor(EU_PTR_SIZE, true, null, context);
}

function EUPointerStaticArray(array) {
	var arrayLength = array.length;
	var pPtr = new EUPointerConstructor(
		arrayLength, false, null, null);

	try {
		Module.writeArrayToMemory(array, pPtr.ptr | 0);
		pPtr.toArray = function() {
			var array = null;
			try {
				var arrBuffer = new ArrayBuffer(arrayLength);
				array = new Uint8Array(arrBuffer);
				array.set(new Uint8Array(Module.HEAPU8.buffer, this.ptr, arrayLength));
			} catch (e) {
			}

			this.free();

			return array;
		};
	} catch (e) {
		pPtr.raiseError(e);
		return null;
	}

	return pPtr;
}

function EUPointerCertOwnerInfo(context) {
	if (context === undefined)
		context = null;

	return new EUPointerConstructor(
			EU_CERT_OWNER_INFO_SIZE, false, 
			function (pPtr) {
				if ((pPtr.ptr | 0) != 0)
				{
					if (context != null)
					{
						Module._EUCtxFreeCertOwnerInfo(
							context | 0, pPtr.ptr);
					}
					else
						Module._EUFreeCertOwnerInfo(pPtr.ptr);
				}
			}, 
			context);
}

function EUPointerSignerInfo(context) {
	if (context === undefined)
		context = null;

	return new EUPointerConstructor(
			EU_SIGN_INFO_SIZE, false, 
			function (pPtr) {
				if ((pPtr.ptr | 0) != 0)
				{
					if (context != null)
					{
						Module._EUCtxFreeSignInfo(
							context | 0, pPtr.ptr);
					}
					else
						Module._EUFreeSignInfo(pPtr.ptr);
				}
			},
			context);
}

function EUPointerSenderInfo(context) {
	if (context === undefined)
		context = null;

	return new EUPointerConstructor(
			EU_SENDER_INFO_SIZE, false, 
			function (pPtr) {
				if ((pPtr.ptr | 0) != 0)
				{
					if (context != null)
					{
						Module._EUCtxFreeSenderInfo(
							context | 0, pPtr.ptr);
					}
					else
						Module._EUFreeSenderInfo(pPtr.ptr);
				}
			}, 
			context);
}

function EUPointerCertificateInfo() {
	return new EUPointerConstructor(
			EU_CERT_INFO_SIZE, false, 
			function (pPtr) {
				if ((pPtr.ptr | 0) != 0)
					Module._EUFreeCertificateInfo(pPtr.ptr);
			},
			null);
}

function EUPointerKeyMedia(typeIndex, devIndex, password) {
	var pPtr = new EUPointerConstructor(
			EU_KEY_MEDIA_SIZE, false, null, null);

	try {
		var pCurPtr = pPtr.ptr | 0;
		
		Module.setValue(pCurPtr, typeIndex | 0, "i32");
		pCurPtr+= EU_INT_SIZE;
		Module.setValue(pCurPtr, devIndex | 0, "i32");
		pCurPtr+= EU_INT_SIZE;
		
		var strArr = UTF8ToCP1251Array(password);
		if (strArr.length > EU_PASS_MAX_LENGTH)
			throw { message: "Invalid parameter"};
		Module.writeArrayToMemory(strArr, pCurPtr);
	} catch (e) {
		pPtr.raiseError(e);
		return null;
	}

	return pPtr;
}

function EUPointerEndUserInfo(euInfo) {
	var pPtr = new EUPointerConstructor(
			EU_USER_INFO_SIZE, false, null, null);

	try {
		var pCurPtr = pPtr.ptr | 0;

		var SetString = function(str, strMaxLength) {
			var strArr = UTF8ToCP1251Array(str);
			if (strArr.length > strMaxLength) {
				throw { message: "Invalid parameter"};
			}

			Module.writeArrayToMemory(strArr, pCurPtr);
			pCurPtr += strMaxLength;
		};

		Module.setValue(pCurPtr, euInfo.GetVersion() | 0, "i32");
		pCurPtr += EU_INT_SIZE;

		SetString(euInfo.GetCommonName(), EU_COMMON_NAME_MAX_LENGTH);
		SetString(euInfo.GetLocality(), EU_LOCALITY_MAX_LENGTH);
		SetString(euInfo.GetState(), EU_STATE_MAX_LENGTH);
		SetString(euInfo.GetOrganization(), EU_ORGANIZATION_MAX_LENGTH);
		SetString(euInfo.GetOrgUnit(), EU_ORG_UNIT_MAX_LENGTH);
		SetString(euInfo.GetTitle(), EU_TITLE_MAX_LENGTH);
		SetString(euInfo.GetStreet(), EU_STREET_MAX_LENGTH);
		SetString(euInfo.GetPhone(), EU_PHONE_MAX_LENGTH);
		SetString(euInfo.GetSurname(), EU_SURNAME_MAX_LENGTH);
		SetString(euInfo.GetGivenname(), EU_GIVENNAME_MAX_LENGTH);
		SetString(euInfo.GetEMail(), EU_EMAIL_MAX_LENGTH);
		SetString(euInfo.GetDNS(), EU_ADDRESS_MAX_LENGTH);
		SetString(euInfo.GetEDRPOUCode(), EU_EDRPOU_MAX_LENGTH);
		SetString(euInfo.GetDRFOCode(), EU_DRFO_MAX_LENGTH);
		SetString(euInfo.GetNBUCode(), EU_NBU_MAX_LENGTH);
		SetString(euInfo.GetSPFMCode(), EU_SPFM_MAX_LENGTH);
		SetString(euInfo.GetOCode(), EU_O_CODE_MAX_LENGTH);
		SetString(euInfo.GetOUCode(), EU_OU_CODE_MAX_LENGTH);
		SetString(euInfo.GetUserCode(), EU_USER_CODE_MAX_LENGTH);
		SetString(euInfo.GetUPN(), EU_UPN_MAX_LENGTH);
		SetString(euInfo.GetUNZR(), EU_UNZR_MAX_LENGTH);
		SetString(euInfo.GetCountry(), EU_COUNTRY_MAX_LENGTH);
	} catch (e) {
		pPtr.raiseError(e);
		return null;
	}

	return pPtr;
}

function EUPointerMemory(size) {
	return new EUPointerConstructor(
			size, false, null, null);
}

function EUArrayFromArrayOfArray(array) {
	this.count = array.length;
	this.arraysPtr = 0;
	this.arraysLengthPtr = 0;

	try {
		this.arraysPtr = Module._malloc(EU_PTR_SIZE * array.length);
		this.arraysLengthPtr = Module._malloc(EU_INT_SIZE * array.length);

		for (var i = 0; i < array.length; i++) {
			Module.setValue((this.arraysPtr + i * EU_PTR_SIZE) | 0, 0);
		}

		for (var i = 0; i < array.length; i++) {
			var pCurPtr = (this.arraysPtr + i * EU_PTR_SIZE) | 0;

			var buffer = _malloc(array[i].length);
			Module.writeArrayToMemory(array[i], buffer);

			setValue(pCurPtr, buffer, "i32*");
			setValue(this.arraysLengthPtr + i * EU_INT_SIZE,
				array[i].length, "i32");
		}
	} catch (e) {
		this.free();
	}

	this.free = function() {
		if (this.arraysPtr == 0)
			return;

		try {
			for (var i = 0; i < this.count; i++) {
				var pCurPtr = Module.getValue(
					(this.arraysPtr + i * EU_PTR_SIZE) | 0, "i32*");
				if (pCurPtr != 0)
					Module._free(pCurPtr);
			}

			Module._free(this.arraysPtr);
			Module._free(this.arraysLengthPtr);
		} catch (e) {}
		
		this.count = 0;
		this.arraysPtr = 0;
		this.arraysLengthPtr = 0;
	};
}

function EUPointerIntArray(array) {
	var pPtr = new EUPointerConstructor(
			EU_INT_SIZE * array.length, false, null, null);

	try {
		var pCurPtr = pPtr.ptr | 0;
		
		for (var i = 0; i < array.length; i++) {
			Module.setValue(pCurPtr, array[i] | 0, "i32");
			pCurPtr+= EU_INT_SIZE;
		}
	} catch (e) {
		pPtr.raiseError(e);
		return null;
	}

	return pPtr;
}

function EUPointerSystemtime(date) {
	var pPtr = new EUPointerConstructor(
			EU_SYSTEMTIME_SIZE, false, null, null);

	try {
		DateToSystemTime(date, pPtr.ptr | 0);
	} catch (e) {
		pPtr.raiseError(e);
		return null;
	}

	return pPtr;
}

function IntFromBool(boolValue) {
	return (boolValue == true) ? 1 : 0;
}

function ParseServersArray(serversArray) {
	var servers = {
		addresses: [],
		ports:[]
	};

	var length = serversArray.length;
	for (var i = 0; i < length; i++) {
		var res = serversArray[i].split(":");
		if (res.length == 2) {
			servers.addresses.push(res[0]);
			servers.ports.push(res[1]);
		} else {
			servers.addresses.push(serversArray[i]);
			servers.ports.push("80");
		}
	}

	return servers;
}

function IsFileSyncSupported() {
	try {
		return (!!FileReaderSync);
	}
	catch (e) {
		return false;
	}
}

function IsFileASyncSupported() {
	try {
		return (!!FileReader);
	}
	catch (e) {
		return false;
	}
}

function MakeUID(length)
{
	var uid = "";
	var uid_chars = 
		"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

	for (var i=0; i < length; i++ ) {
		uid += uid_chars.charAt(Math.floor(
			Math.random() * uid_chars.length));
	}

	return uid;
}

//=============================================================================

//var EU_MODULE_INITIALIZE_ON_LOAD = 
//	((typeof EU_MODULE_INITIALIZE_ON_LOAD) != 'undefined') ? 
//		EU_MODULE_INITIALIZE_ON_LOAD : true;

//-----------------------------------------------------------------------------

export
function EUSignCPModuleInitialize(initCallback) { //SD added initCallback
    if (typeof(EUSignCPModuleInitialized) != "function" && typeof initCallback !=='undefined')
    {
        var EUSignCPModuleInitialized = initCallback;
    }

	Module.setStatus.last = null;
	Module['setStatus']('(ініціалізація...)');
	setTimeout(function() {
		var isInitialized = false;
		try {
			var error = Module._EUInitialize();
			if (error != EU_ERROR_NONE)
				Module.setStatus('(не ініціалізовано)');
			else {
				Module.setStatus('(ініціалізовано)');
				isInitialized = true;
			}
		} catch(e) {
			Module.setStatus('(не ініціалізовано)');
		}
		
		try {
			if (typeof(EUSignCPModuleInitialized) == "function")
				EUSignCPModuleInitialized(isInitialized);
		} catch (e) {
		}
	}, 100);
}

//-----------------------------------------------------------------------------

//SD - moved to global
// export var Module = {
//............

//=============================================================================

var EUSignCP = NewClass({
	"Vendor": "JSC IIT",
	"ClassVersion": "1.3.54",
	"ClassName": "EUSignCP",
	"BaseLibraryVersion": "1.3.1.101",
	"errorLangCode": EU_DEFAULT_LANG,
	"privKeyOwnerInfo": null,
	"isFileSyncAPISupported": false,
	"isFileASyncAPISupported": false,
	"stringEncoder": new StringEncoder("UTF-8", false)
},
function() {
},
{
//-----------------------------------------------------------------------------
	_GetFileSignTimeInfoSync: function(signIndex, signedFile) {
		if (!EUFS.link(signedFile)) {
			this.RaiseError(EU_ERROR_JS_READ_FILE);
		}

		var pTimeInfoPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUGetFileSignTimeInfo',
				'number',
				['number', 'array', 'number'],
				[signIndex, 
					UTF8ToCP1251Array(EUFS.getFilePath(signedFile)),
					pTimeInfoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pTimeInfoPtr.free();
			EUFS.unlink(signedFile);

			this.RaiseError(error);
		}

		EUFS.unlink(signedFile);

		var timeInfoPtr, timeInfo;

		timeInfoPtr = pTimeInfoPtr.toPtr();
		timeInfo = new EndUserTimeInfo(timeInfoPtr);
		Module._EUFreeTimeInfo(timeInfoPtr);

		return timeInfo;
	},
//-----------------------------------------------------------------------------
	GetErrorDescription: function(errorCode, langCode) {
		try {
			if ((errorCode & EU_ERROR_JS_ERRORS) == EU_ERROR_JS_ERRORS){
				if (arguments.length == 2) {
					return EU_ERRORS_STRINGS[langCode][errorCode];
				} else {
					return EU_ERRORS_STRINGS[this.errorLangCode][errorCode];
				}
			}

			var strPtr = 0;

			if (arguments.length == 2) {
				strPtr = Module._EUGetErrorLangDesc(
					errorCode, langCode);
			} else {
				strPtr = Module._EUGetErrorLangDesc(
					errorCode, this.errorLangCode);
			}

			return CP1251PointerToUTF8(strPtr);
		} catch (e) {
			return null;
		}
	},
	MakeError: function(errorCode) {
		var errorMsg = this.GetErrorDescription(errorCode);
		if (errorMsg == null)
			errorMsg = '';

		return new EUSignCPException(errorCode, errorMsg, '');
	},
	RaiseError: function(errorCode) {
		throw this.MakeError(errorCode);
	},
//-----------------------------------------------------------------------------
	GetVersion: function() {
		return this.ClassVersion + '(' + this.BaseLibraryVersion + ')';
	},
//-----------------------------------------------------------------------------
	Initialize: function() {
		var error;

		try {
			this.isFileSyncAPISupported =
				IsFileSyncSupported() & EUFS.staticInit();
			this.isFileASyncAPISupported = IsFileASyncSupported();

			error = Module._EUInitialize();
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);

		return EU_ERROR_NONE;
	},
	Finalize: function() {
		var error;

		try {
			Module._EUFinalize();
			error = EU_ERROR_NONE;
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		this.privKeyOwnerInfo = null;

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);

		return EU_ERROR_NONE;
	},
	IsInitialized: function() {
		var isInitialized;
		
		try {
			isInitialized = 
				(Module._EUIsInitialized() != EU_FALSE);
		} catch (e) {
			isInitialized = false;
		}
		
		return isInitialized;
	},
	SetErrorMessageLanguage: function(langCode) {
		if (typeof langCode == 'string') {
			langCode = langCode.toLocaleLowerCase();
			switch (langCode) {
				case 'en':
					langCode = EU_EN_LANG;
					break;
				case 'ru':
					langCode = EU_RU_LANG;
					break;
					
				case 'uk':
				case 'ua':
				default:
					langCode = EU_UA_LANG;
					break;
			}
		}
		this.errorLangCode = langCode;
		Module.errorLanguage = langCode;
	},
	GetErrorDesc: function (errorCode, langCode) {
		var errorDesc = this.GetErrorDescription(errorCode, langCode);

		if (errorDesc == null)
			this.RaiseError(EU_ERROR_JS_LIBRARY_LOAD);

		return errorDesc;
	},
//-----------------------------------------------------------------------------
	CheckMaxDataSize: function(data) {
		if (data.length > Module.MAX_DATA_SIZE)
			this.RaiseError(EU_ERROR_BAD_PARAMETER);
	},
	Base64Encode: function(data) {
		this.CheckMaxDataSize(data);

		var strPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUBASE64Encode',
				'number',
				['array', 'number', 'number'],
				[data, data.length, strPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			strPtr.free();
			this.RaiseError(error);
		}
		
		return strPtr.toString();
	}, 
	Base64Decode: function(data) {
		this.CheckMaxDataSize(data);

		var arrPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUBASE64Decode',
				'number',
				['array', 'number', 'number'],
				[StringToCString(data),
					arrPtr.ptr, arrPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			arrPtr.free();
			this.RaiseError(error);
		}
		
		return arrPtr.toArray();
	},
	SetJavaStringCompliant: function(compliant) {
		this.stringEncoder = new StringEncoder(
			this.stringEncoder.charset,
			compliant);
	},
	SetCharset: function(charset) {
		try {
			var encoder = new StringEncoder(
				charset,
				this.stringEncoder.javaCompliant);
			this.stringEncoder = encoder;
		} catch (e) {
			this.RaiseError(EU_ERROR_BAD_PARAMETER);
		}
	},
	GetCharset: function() {
		if (this.stringEncoder == null)
			this.RaiseError(EU_ERROR_BAD_PARAMETER);

		return this.stringEncoder.charset;
	},
	StringToArray: function(data) {
		try {
			return this.stringEncoder.encode(data);
		} catch (e) {
			this.RaiseError(EU_ERROR_BAD_PARAMETER);
		}
	},
	ArrayToString: function(data) {
		try {
			return this.stringEncoder.decode(data);
		} catch (e) {
			this.RaiseError(EU_ERROR_BAD_PARAMETER);
		}
	},
	ReadFile: function(file, onSuccess, onError) {
		var useASyncAPI = (arguments.length == 3);

		if (file == null) {
			if (useASyncAPI) {
				onError(this.MakeError(EU_ERROR_BAD_PARAMETER));
				return;
			}

			this.RaiseError(EU_ERROR_BAD_PARAMETER);
			return;
		}

		if (!this.isFileSyncAPISupported && 
			!this.isFileASyncAPISupported) {
			if (useASyncAPI) {
				onError(this.MakeError(EU_ERROR_NOT_SUPPORTED));
				return;
			}

			this.RaiseError(EU_ERROR_NOT_SUPPORTED);
			return;
		}

		if (useASyncAPI) {
			var pThis = this;
			var _onSuccess = function(evt) {
				if (evt.target.readyState != FileReader.DONE)
					return;

				try {
					var loadedFile = new EndUserFile();

					loadedFile.SetTransferableObject({
						'file': file,
						'data': new Uint8Array(evt.target.result)
					});

					onSuccess(loadedFile);
				} catch (e) {
					onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				}
			};

			var _onError = function(e) {
				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
			};

			var fileReader = new FileReader();
			fileReader.onloadend = _onSuccess;
			fileReader.onerror = _onError;
			fileReader.readAsArrayBuffer(file);
			return;
		}

		try {
			var fileReader = new FileReaderSync();
			var fileData = fileReader.readAsArrayBuffer(file);
			var loadedFile = new EndUserFile();

			loadedFile.SetTransferableObject({
				'file': file, 'data': new Uint8Array(fileData)
			});

			return loadedFile;
		} catch (e) {
			this.RaiseError(EU_ERROR_JS_READ_FILE);
		}
	},
	ReadFiles: function (files, onSuccess, onError) {
		var useASyncAPI = (arguments.length == 3);

		if (files.length <= 0) {
			if (useASyncAPI) {
				onError(this.MakeError(EU_ERROR_BAD_PARAMETER));
				return;
			}
			
			this.RaiseError(EU_ERROR_BAD_PARAMETER);
			return;
		}

		if (useASyncAPI) {
			var curIndex = 0;
			var processedFiles = [];

			var pThis = this;
			var _onSuccess = function(readedFile) {
				processedFiles.push(readedFile);
				curIndex++;
				
				if (curIndex < files.length) {
					pThis.ReadFile(files[curIndex], _onSuccess, onError);
					return;
				}

				onSuccess(processedFiles);
			};

			pThis.ReadFile(files[curIndex], _onSuccess, onError);
			return;
		}
		
		var processedFiles = [];
		for (var i = 0; i < files.length; i++) {
			processedFiles.push(this.ReadFile(files[i]));
		}

		return processedFiles;
	},
	LoadDataFromServer: function(path, onSuccess, onError, asByteArray) {
		var pThis = this;
		try {
			var httpRequest;
			var url;

			if (XMLHttpRequest)
				httpRequest = new XMLHttpRequest();
			else
				httpRequest = new ActiveXObject("Microsoft.XMLHTTP");

			httpRequest.onload = function() {
				if (httpRequest.readyState != 4)
					return;

				if (httpRequest.status == 200) {
					if (asByteArray) {
						onSuccess(new Uint8Array(this.response));
					} else {
						onSuccess(httpRequest.responseText);
					}
				}
				else {
					onError(pThis.MakeError(EU_ERROR_DOWNLOAD_FILE));
				}
			};

			httpRequest.onerror = function() {
				onError(pThis.MakeError(EU_ERROR_DOWNLOAD_FILE));
			};

			if (path.indexOf('http://') != 0 && 
					path.indexOf('https://') != 0) {
				if (!location.origin) {
					location.origin = location.protocol + 
						"//" + location.hostname + 
						(location.port ? ':' + location.port: '');
				}

				url = location.origin + path;
			} else {
				url = path;
			}

			httpRequest.open("GET", url, true);
			if (asByteArray)
				httpRequest.responseType = 'arraybuffer';
			httpRequest.send();
		} catch (e) {
			onError(pThis.MakeError(EU_ERROR_DOWNLOAD_FILE));
		}
	},
//-----------------------------------------------------------------------------
	DoesNeedSetSettings: function() {
		try {
			return (Module._EUDoesNeedSetSettings() != EU_FALSE);
		} catch (e) {
			this.RaiseError(EU_ERROR_UNKNOWN);
		}
	},
	SetXMLHTTPProxyService: function(proxyServicePath) {
		XMLHTTPProxyService = proxyServicePath;
	},
	SetXMLHTTPDirectAccess: function(directAccess) {
		XMLHTTPDirectAccess = directAccess;
	},
	AddXMLHTTPDirectAccessAddress: function(address) {
		XMLHTTPDirectAccessAddresses.push(address);
	},
	InitializeMandatorySettings: function() {
		var fs = this.CreateFileStoreSettings();
		this.SetFileStoreSettings(fs);

		var proxy = this.CreateProxySettings();
		this.SetProxySettings(proxy);

		var tsp = this.CreateTSPSettings();
		this.SetTSPSettings(tsp);
		
		var ocsp = this.CreateOCSPSettings();
		this.SetOCSPSettings(ocsp);
		
		var ldap = this.CreateLDAPSettings();
		this.SetLDAPSettings(ldap);	
	},
	CreateFileStoreSettings:function() {
		return EndUserFileStoreSettings("/certificates", 
			false, false, false, false, false, false, 3600);
	},
	SetFileStoreSettings: function(settings) {
		var error;
		
		try {
			error = Module.ccall('EUSetFileStoreSettings',
				'number',
				['array', 'number', 'number', 'number', 'number',
					'number', 'number', 'number'],
				[UTF8ToCP1251Array(settings.path),
					IntFromBool(settings.checkCRLs),
					IntFromBool(settings.autoRefresh),
					IntFromBool(settings.ownCRLsOnly),
					IntFromBool(settings.fullAndDeltaCRLs),
					IntFromBool(settings.autoDownloadCRLs),
					IntFromBool(settings.saveLoadedCerts),
					settings.expireTime]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	CreateProxySettings:function() {
		return EndUserProxySettings(false, true,
			"", "3128", "", "", false);
	},
	SetProxySettings:function(settings) {
		var error;
		
		try {
			error = Module.ccall('EUSetProxySettings',
				'number',
				['number', 'number', 'array', 'array',
					'array', 'array', 'number'],
				[IntFromBool(settings.useProxy),
					IntFromBool(settings.anonymous),
					StringToCString(settings.address),
					StringToCString(settings.port),
					StringToCString(settings.user),
					StringToCString(settings.password),
					IntFromBool(settings.savePassword)]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	CreateTSPSettings:function() {
		return EndUserTSPSettings(false,
			"", "80");
	},
	SetTSPSettings:function(settings) {
		var error;
		
		try {
			error = Module.ccall('EUSetTSPSettings',
				'number',
				['number', 'array', 'array'],
				[IntFromBool(settings.getStamps),
					StringToCString(settings.address),
					StringToCString(settings.port)]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	CreateOCSPSettings:function() {
		return EndUserOCSPSettings(false, false,
			"", "80");
	},
	SetOCSPSettings:function(settings) {
		var error;
		
		try {
			error = Module.ccall('EUSetOCSPSettings',
				'number',
				['number', 'number', 'array', 'array'],
				[IntFromBool(settings.useOCSP),
					IntFromBool(settings.beforeStore),
					StringToCString(settings.address),
					StringToCString(settings.port)]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	CreateCMPSettings:function() {
		return EndUserCMPSettings(false, "", "80", "");
	},
	SetCMPSettings:function(settings) {
		var error;
		
		try {
			error = Module.ccall('EUSetCMPSettings',
				'number',
				['number', 'array', 'array', 'array'],
				[IntFromBool(settings.useCMP),
					StringToCString(settings.address),
					StringToCString(settings.port),
					UTF8ToCP1251Array(settings.commonName)]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	CreateLDAPSettings:function() {
		return EndUserLDAPSettings(false, "", "80",
			true, "", "");
	},
	SetLDAPSettings:function(settings) {
		var error;
		
		try {
			error = Module.ccall('EUSetLDAPSettings',
				'number',
				['number', 'array', 'array',
					'number', 'array', 'array'],
				[IntFromBool(settings.useLDAP),
					StringToCString(settings.address),
					StringToCString(settings.port),
					IntFromBool(settings.anonymous),
					StringToCString(settings.user),
					StringToCString(settings.password)]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	CreateModeSettings:function() {
		return EndUserModeSettings(false);
	},
	SetModeSettings:function(settings) {
		var error;
		
		try {
			error = Module.ccall('EUSetModeSettings',
				'number',
				['number'],
				[IntFromBool(settings.offlineMode)]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	CreateOCSPAccessInfoModeSettings:function() {
		return EndUserOCSPAccessInfoModeSettings(false);
	},
	SetOCSPAccessInfoModeSettings:function(settings) {
		var error;
		
		try {
			error = Module.ccall('EUSetOCSPAccessInfoModeSettings',
				'number',
				['number'],
				[IntFromBool(settings.enabled)]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	CreateOCSPAccessInfoSettings:function() {
		return EndUserOCSPAccessInfoSettings("", "", "");
	},
	SetOCSPAccessInfoSettings:function(settings) {
		var error;
		
		try {
			error = Module.ccall('EUSetOCSPAccessInfoSettings',
				'number',
				['array', 'array', 'array'],
				[UTF8ToCP1251Array(settings.issuerCN),
					StringToCString(settings.address),
					StringToCString(settings.port)]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	SetRuntimeParameter: function(name, value) {
		var error;
		if (typeof value != 'boolean' && typeof value != 'number') {
			this.RaiseError(EU_ERROR_BAD_PARAMETER);
		}
		
		if (typeof value == 'boolean')
			value = IntFromBool(value);

		var intPtr = EUPointerInt();

		try {
			Module.setValue(intPtr.ptr,
				value | 0, "i32");

			error = Module.ccall('EUSetRuntimeParameter',
				'number',
				['array', 'number', 'number'],
				[UTF8ToCP1251Array(name), 
					intPtr.ptr, EU_INT_SIZE]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
			intPtr.free();
		}

		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}

		intPtr.free();
	},
	SetOCSPResponseExpireTime:function(expireTime) {
		var error;
		
		try {
			error = Module.ccall('EUSetOCSPResponseExpireTime',
				'number',
				['number'],
				[expireTime]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
//-----------------------------------------------------------------------------
	SaveCertificate: function(certificate) {
		var error;

		this.CheckMaxDataSize(certificate);

		try {
			error = Module.ccall('EUSaveCertificate',
				'number',
				['array', 'number'],
				[certificate, certificate.length]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	SaveCertificates: function(certificates) {
		var error;

		this.CheckMaxDataSize(certificates);

		try {
			error = Module.ccall('EUSaveCertificates',
				'number',
				['array', 'number'],
				[certificates, certificates.length]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	SaveCertificatesEx: function(certificates, trustedStore) {
		var error;

		this.CheckMaxDataSize(certificates);
		if (trustedStore)
			this.CheckMaxDataSize(trustedStore);

		try {
			error = Module.ccall('EUSaveCertificatesEx',
				'number',
				['array', 'number', 
					trustedStore ? 'array' : 'number', 'number'],
				[certificates, certificates.length,
					trustedStore ? trustedStore : 0, 
					trustedStore ? trustedStore.length : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	SaveCRL: function(isFullCRL, crl) {
		var error;

		this.CheckMaxDataSize(crl);

		try {
			error = Module.ccall('EUSaveCRL',
				'number',
				['number', 'array', 'number'],
				[IntFromBool(isFullCRL), 
					crl, crl.length]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	GetCertificate: function(issuer, serial, asBase64String) {
		var pPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUGetCertificate',
				'number',
				['array', 'array', 'number', 'number', 'number'],
				[UTF8ToCP1251Array(issuer), 
				 UTF8ToCP1251Array(serial), 
					asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return pPtr.toString(true);
		else 
			return pPtr.toArray();
	},
	GetCertificates: function() {
		var pPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUGetCertificates',
				'number',
				['number', 'number'],
				[pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		return pPtr.toArray();
	},
	GetCertificatesByKeyInfo: function(keyInfo, cmpServers) {
		this.CheckMaxDataSize(keyInfo);

		var pPtr = EUPointerArray();
		var error;

		var servers = ParseServersArray(cmpServers);
		var addressesArray = intArrayFromStrings(servers.addresses);
		var portsArray = intArrayFromStrings(servers.ports);

		try {
			error = Module.ccall('EUGetCertificatesByKeyInfo',
				'number',
				['array', 'number', 'array', 'array', 'number', 'number'],
				[keyInfo, keyInfo.length, 
					addressesArray, portsArray,
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		return pPtr.toArray();
	},
	ParseCertificate: function(certificate) {
		this.CheckMaxDataSize(certificate);

		var infoPtr = EUPointerCertificateInfo();
		var error;

		try {
			error = Module.ccall('EUParseCertificate',
				'number',
				['array', 'number', 'number'],
				[certificate, certificate.length, infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		var info = new EndUserCertificateInfo(infoPtr.ptr);
		infoPtr.free();

		return info;
	},
	ParseCertificateEx: function(certificate) {
		this.CheckMaxDataSize(certificate);

		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUParseCertificateEx',
				'number',
				['array', 'number', 'number'],
				[certificate, certificate.length, pPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		var infoPtr = pPtr.toPtr();
		var info = new EndUserCertificateInfoEx(infoPtr);
		Module._EUFreeCertificateInfoEx(infoPtr);

		return info;
	},
	GetCRInfo: function(request) {
		this.CheckMaxDataSize(request);

		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUGetCRInfo',
				'number',
				['array', 'number', 'number'],
				[request, request.length, pPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		var infoPtr = pPtr.toPtr();
		var info = new EndUserRequestInfo(infoPtr);
		Module._EUFreeCRInfo(infoPtr);

		return info;
	},
	CheckCertificate: function(certificate) {
		this.CheckMaxDataSize(certificate);

		var infoPtr = EUPointerCertificateInfo();
		var error;

		try {
			error = Module.ccall('EUCheckCertificate',
				'number',
				['array', 'number'],
				[certificate, certificate.length]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		return true;
	},
	EnumCertificatesEx: function(
		subjectType, subjectSubType, 
		certKeyType, keyUsage, index) {
		var pCertInfoExPtr = EUPointer();
		var certArrPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUEnumCertificatesEx',
				'number',
				['number', 'number', 'number', 'number', 
					'number', 'number', 'number', 'number'],
				[subjectType, subjectSubType,
					certKeyType, keyUsage,
					index, pCertInfoExPtr.ptr, 
					certArrPtr.ptr, certArrPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pCertInfoExPtr.free();
			certArrPtr.free();

			if (error == EU_WARNING_END_OF_ENUM)
				return null;

			this.RaiseError(error);
		}

		var certInfoExPtr, certInfoEx;

		certInfoExPtr = pCertInfoExPtr.toPtr();
		certInfoEx = new EndUserCertificateInfoEx(certInfoExPtr);
		Module._EUFreeCertificateInfoEx(certInfoExPtr);

		return new EndUserCertificate(certInfoEx, certArrPtr.toArray());
	},
//-----------------------------------------------------------------------------
	IsPrivateKeyReaded: function() {
		var error = EU_ERROR_NONE;
		var isReaded;
		
		try {
			isReaded = (Module._EUIsPrivateKeyReaded() != EU_FALSE);
			error = EU_ERROR_NONE;
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
			isReaded = false;
		}
		
		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}

		return isReaded;
	},
	ReadPrivateKeyBinary: function(privateKey, password) {
		this.CheckMaxDataSize(privateKey);

		var infoPtr = EUPointerCertOwnerInfo();
		var error;

		try {
			error = Module.ccall('EUReadPrivateKeyBinary',
				'number',
				['array', 'number', 'array', 'number'],
				[privateKey, privateKey.length,
					UTF8ToCP1251Array(password), infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		this.privKeyOwnerInfo = new EndUserOwnerInfo(infoPtr.ptr);
		infoPtr.free();

		return this.privKeyOwnerInfo;
	},
	ResetPrivateKey: function() {
		try {
			Module.ccall('EUResetPrivateKey', "",
				[], []);
		} catch (e) {
		}

		this.privKeyOwnerInfo = null;
	},
	GetPrivateKeyOwnerInfo: function() {
		var error = EU_ERROR_NONE;
		try {
			if (Module._EUIsPrivateKeyReaded() == EU_FALSE) {
				this.privKeyOwnerInfo = null;
				error = EU_ERROR_UNKNOWN;
			}
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}
		
		return this.privKeyOwnerInfo;
	},
	GetKeyInfoBinary: function (privateKey, password) {
		this.CheckMaxDataSize(privateKey);

		var arrPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUGetKeyInfoBinary',
				'number',
				['array', 'number', 'array', 'number', 'number'],
				[privateKey, privateKey.length, 
					UTF8ToCP1251Array(password), 
					arrPtr.ptr, arrPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			arrPtr.free();
			this.RaiseError(error);
		}

		return arrPtr.toArray();
	},
	EnumOwnCertificates: function(index) {
		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUEnumOwnCertificates',
				'number',
				['number', 'number'],
				[index, pPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			
			if (error == EU_WARNING_END_OF_ENUM)
				return null;

			this.RaiseError(error);
		}

		var infoPtr = pPtr.toPtr();
		var info = new EndUserCertificateInfoEx(infoPtr);
		Module._EUFreeCertificateInfoEx(infoPtr);

		return info;
	},
	GeneratePrivateKey: function(password,
		uaKeysType, uaDSKeysSpec, useDSKeyAsKEP, uaKEPKeysSpec,
		internationalKeysType, internationalKeysSpec, 
		userInfo, extKeyUsages) {
		var error;

		var kmPtr = EUPointerKeyMedia(0, 0, password);
		if (kmPtr == null)
			this.RaiseError(EU_ERROR_BAD_PARAMETER);

		var userInfoPtr = null;
		if (userInfo != null) {
			userInfoPtr = EUPointerEndUserInfo(userInfo);
			if (userInfoPtr == null) {
				kmPtr.free();
				this.RaiseError(EU_ERROR_BAD_PARAMETER);
			}
		}

		var pkPtr = EUPointerArray();
		var pkInfoPtr = EUPointerArray();

		var uaReqPtr = null, uaReqNamePtr = null, 
			uaKEPReqPtr = null, uaKEPReqNamePtr = null;
		if (uaKeysType != EU_KEYS_TYPE_NONE) {
			uaReqPtr = EUPointerArray();
			uaReqNamePtr = EUPointerMemory(EU_PATH_MAX_LENGTH);

			if (!useDSKeyAsKEP) {
				uaKEPReqPtr = EUPointerArray();
				uaKEPReqNamePtr = EUPointerMemory(EU_PATH_MAX_LENGTH);
			}
		}

		var intReqPtr = null, intReqNamePtr = null;
		if (internationalKeysType != EU_KEYS_TYPE_NONE) {
			intReqPtr = EUPointerArray();
			intReqNamePtr = EUPointerMemory(EU_PATH_MAX_LENGTH);
		}

		var _free = function() {
			kmPtr.free();
			pkPtr.free();
			pkInfoPtr.free();
			if (userInfoPtr != null)
				userInfoPtr.free();
			if (uaReqPtr != null)
				uaReqPtr.free();
			if (uaReqNamePtr != null)
				uaReqNamePtr.free();
			if (uaKEPReqPtr != null)
				uaKEPReqPtr.free();
			if (uaKEPReqNamePtr != null)
				uaKEPReqNamePtr.free();
			if (intReqPtr != null)
				intReqPtr.free();
			if (intReqNamePtr != null)
				intReqNamePtr.free();
		};

		try {
			error = Module.ccall('EUGeneratePrivateKeyEx',
				'number',
				['number', 'number', 
				 'number', 'number', 'number', 'number',
				  'number', 'number', 'number',
				  'number', 
				  (extKeyUsages != null) ? 'array' : 'number',
				  'number', 'number',
				  'number', 'number',
				  'number', 'number', 'number',
				  'number', 'number', 'number',
				  'number', 'number', 'number',],
				[kmPtr.ptr, EU_FALSE, 
				 uaKeysType, uaDSKeysSpec, uaKEPKeysSpec, null,
				 internationalKeysType, internationalKeysSpec, null,
				 (userInfo != null) ? 
					userInfoPtr.ptr : null, 
				 (extKeyUsages != null) ? 
					UTF8ToCP1251Array(extKeyUsages) : null,
				 pkPtr.ptr, pkPtr.lengthPtr,
				 pkInfoPtr.ptr, pkInfoPtr.lengthPtr,
				 (uaReqPtr != null) ? uaReqPtr.ptr : null,
				 (uaReqPtr != null) ? uaReqPtr.lengthPtr : null,
				 (uaReqNamePtr != null) ? uaReqNamePtr.ptr : null, 
				 (uaKEPReqPtr != null) ? uaKEPReqPtr.ptr : null,
				 (uaKEPReqPtr != null) ? uaKEPReqPtr.lengthPtr : null,
				 (uaKEPReqNamePtr != null) ? uaKEPReqNamePtr.ptr : null,
				 (intReqPtr != null) ? intReqPtr.ptr : null,
				 (intReqPtr != null) ? intReqPtr.lengthPtr : null,
				 (intReqNamePtr != null) ? intReqNamePtr.ptr : null]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			_free();
			this.RaiseError(error);
		}

		var _toString = function(strPtr) {
			var str = CP1251PointerToUTF8(strPtr);
			var lastInd = str.lastIndexOf("/");
			if (lastInd < 0)
				return str;

			return str.substring(lastInd + 1, str.length);
		};
		
		var euPrivateKey = EndUserPrivateKey(
			pkPtr.toArray(), pkInfoPtr.toArray(),
			(uaReqPtr != null) ? uaReqPtr.toArray() : null,
			(uaReqNamePtr != null) ? _toString(uaReqNamePtr.ptr) : null,
			(uaKEPReqPtr != null) ? uaKEPReqPtr.toArray() : null,
			(uaKEPReqNamePtr != null) ? _toString(uaKEPReqNamePtr.ptr) : null,
			(intReqPtr != null) ? intReqPtr.toArray() : null,
			(intReqNamePtr != null) ? _toString(intReqNamePtr.ptr) : null);

		_free();

		return euPrivateKey;
	},
	MakeNewCertificate: function(privateKey, password,
		uaKeysType, uaDSKeysSpec, useDSKeyAsKEP, uaKEPKeysSpec,
		internationalKeysType, internationalKeysSpec, 
		newPrivateKeyPassword) {
		this.CheckMaxDataSize(privateKey);
		
		var pkPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUMakeNewCertificate',
				'number',
				['number', 'array', 'number', 'array',
				  'number', 'number', 'number', 
				  'number', 'number',
				  'number', 'number', 'number',
				  'number', 'array',
				  'number', 'number'],
				[null, privateKey, privateKey.length, UTF8ToCP1251Array(password),
				 uaKeysType, uaDSKeysSpec, IntFromBool(useDSKeyAsKEP), 
				 uaKEPKeysSpec, null,
				 internationalKeysType, internationalKeysSpec, null,
				 null, UTF8ToCP1251Array(newPrivateKeyPassword), 
				 pkPtr.ptr, pkPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pkPtr.free();
			this.RaiseError(error);
		}

		return pkPtr.toArray();
	},
	ChangeSoftwarePrivateKeyPassword: function(
		privateKey, oldPassword, newPassword) {
		this.CheckMaxDataSize(privateKey);

		var arrPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUChangeSoftwarePrivateKeyPassword',
				'number',
				['array', 'number', 'array', 'array', 'number', 'number'],
				[privateKey, privateKey.length, 
					UTF8ToCP1251Array(oldPassword), 
					UTF8ToCP1251Array(newPassword), 
					arrPtr.ptr, arrPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			arrPtr.free();
			this.RaiseError(error);
		}

		return arrPtr.toArray();
	},
	EnumJKSPrivateKeys: function(container, index) {
		this.CheckMaxDataSize(container);

		var keyAliasPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUEnumJKSPrivateKeys',
				'number',
				['array', 'number',  'number', 'number'],
				[container, container.length,
					index, keyAliasPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			keyAliasPtr.free();
			this.RaiseError(error);
		}

		return keyAliasPtr.toString();
	},
	GetJKSPrivateKey: function(container, keyAlias) {
		this.CheckMaxDataSize(container);

		var keyPtr = EUPointerArray();
		var certsCountPtr = EUPointerDWORD();
		var certsPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUGetJKSPrivateKey',
				'number',
				['array', 'number',  'array', 
					'number', 'number', 'number', 'number', 'number'],
				[container, container.length,
					UTF8ToCP1251Array(keyAlias), 
					keyPtr.ptr, keyPtr.lengthPtr, certsCountPtr.ptr,
					certsPtr.ptr, certsPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			keyPtr.free();
			certsCountPtr.free();
			certsPtr.free();
			this.RaiseError(error);
		}

		var count = certsCountPtr.toNumber();

		return new EndUserJKSPrivateKey(
			keyPtr.toArray(), 
			certsPtr.toArrayOfByteArrays(count));
	},
	ChangeOwnCertificatesStatus: function(requestType, revocationReason) {
		var error;

		try {
			error = Module.ccall('EUChangeOwnCertificatesStatus',
				'number',
				['number', 'number'],
				[requestType, revocationReason]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}
	},
	CtxReadPrivateKeyBinary: function(context, privateKey, password) {
		this.CheckMaxDataSize(privateKey);

		var pkCtxPtr = EUPointer(); 
		var infoPtr = EUPointerCertOwnerInfo(context.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxReadPrivateKeyBinary',
				'number',
				['number', 'array', 'number', 'array', 'number', 'number'],
				[context.GetContext(), privateKey, privateKey.length,
					UTF8ToCP1251Array(password), 
					pkCtxPtr.ptr, infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pkCtxPtr.free();
			infoPtr.free();
			this.RaiseError(error);
		}

		var privateKeyContext = new EndUserPrivateKeyContext(
			pkCtxPtr.toPtr(), new EndUserOwnerInfo(infoPtr.ptr));
		infoPtr.free();

		return privateKeyContext;
	},
	CtxFreePrivateKey: function(privateKeyContext) {
		try {
			Module._EUCtxFreePrivateKey(
				privateKeyContext.GetContext()|0);
		} catch (e) {
		}
	},
	CtxGetOwnCertificate: function(
		privateKeyContext, certKeyType, keyUsage) {
		var pkCtx = privateKeyContext.GetContext();
		var pCertInfoExPtr = EUPointer();
		var certArrPtr = EUPointerArray(pkCtx);
		var error;

		try {
			error = Module.ccall('EUCtxGetOwnCertificate',
				'number',
				['number', 'number', 'number', 
					'number', 'number', 'number'],
				[pkCtx, certKeyType, keyUsage, pCertInfoExPtr.ptr,
					certArrPtr.ptr, certArrPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pCertInfoExPtr.free();
			certArrPtr.free();

			this.RaiseError(error);
		}

		var certInfoExPtr, certInfoEx;

		certInfoExPtr = pCertInfoExPtr.toPtr();
		certInfoEx = new EndUserCertificateInfoEx(certInfoExPtr);
		Module._EUCtxFreeCertificateInfoEx(pkCtx|0, certInfoExPtr);

		return new EndUserCertificate(certInfoEx, certArrPtr.toArray());
	},
	CtxEnumOwnCertificates: function(privateKeyContext, index) {
		var pkCtx = privateKeyContext.GetContext();
		var pCertInfoExPtr = EUPointer();
		var certArrPtr = EUPointerArray(pkCtx);
		var error;

		try {
			error = Module.ccall('EUCtxEnumOwnCertificates',
				'number',
				['number', 'number', 'number', 'number', 'number'],
				[pkCtx, index, pCertInfoExPtr.ptr, 
					certArrPtr.ptr, certArrPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pCertInfoExPtr.free();
			certArrPtr.free();

			if (error == EU_WARNING_END_OF_ENUM)
				return null;

			this.RaiseError(error);
		}

		var certInfoExPtr, certInfoEx;

		certInfoExPtr = pCertInfoExPtr.toPtr();
		certInfoEx = new EndUserCertificateInfoEx(certInfoExPtr);
		Module._EUCtxFreeCertificateInfoEx(pkCtx|0, certInfoExPtr);

		return new EndUserCertificate(certInfoEx, certArrPtr.toArray());
	},
	CtxEnumPrivateKeyInfo: function(privateKeyContext, index) {
		var dwordKeyTypePtr = EUPointerDWORD();
		var dwordKeyUsagePtr = EUPointerDWORD();
		var dwordKeyIDsCountPtr = EUPointerDWORD();
		var keyIDsPtr = EUPointer(privateKeyContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxEnumPrivateKeyInfo',
				'number',
				['number', 'number',
					'number', 'number', 'number', 'number'],
				[privateKeyContext.GetContext() | 0, index,
					dwordKeyTypePtr.ptr, dwordKeyUsagePtr.ptr, 
					dwordKeyIDsCountPtr.ptr, keyIDsPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			dwordKeyTypePtr.free();
			dwordKeyUsagePtr.free();
			dwordKeyIDsCountPtr.free();
			keyIDsPtr.free();
			
			if (error == EU_WARNING_END_OF_ENUM)
				return null;
			
			this.RaiseError(error);
		}

		var keyType = dwordKeyTypePtr.toNumber();
		var keyUsage = dwordKeyUsagePtr.toNumber();
		var keyIDsCount = dwordKeyIDsCountPtr.toNumber();
		var keyIDs = keyIDsPtr.toStringArray();
		if (keyIDsCount != keyIDs.length)
			this.RaiseError(EU_ERROR_BAD_PARAMETER);

		return EndUserPrivateKeyInfo(
			keyType, keyUsage, keyIDs);
	},
	CtxExportPrivateKeyContainer: function(privateKeyContext, 
		password, keyID, asBase64String) {
		var pPtr = EUPointerArray(
			privateKeyContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxExportPrivateKeyContainer',
				'number',
				['number', 'array', 'array', 
					'number', 'number'],
				[privateKeyContext.GetContext(), 
					UTF8ToCP1251Array(password),
					UTF8ToCP1251Array(keyID),
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else
			return pPtr.toArray();
	},
	CtxExportPrivateKeyPFXContainer: function(privateKeyContext,
		password, exportCerts, trustedKeyIDs, keyIDs, asBase64String) {
		var pPtr = EUPointerArray(
			privateKeyContext.GetContext());
		var error;

		var trustedKeyIDsArray = [];
		for (var i = 0; i < trustedKeyIDs.length; i++) {
			trustedKeyIDsArray.push(IntFromBool(exportCerts));
		}
		
		try {
			var trustedKeyIDsPtr = 
				EUPointerIntArray(trustedKeyIDsArray);
			error = Module.ccall('EUCtxExportPrivateKeyPFXContainer',
				'number',
				['number', 'array', 'number', 'number', 'number', 
					'array', 'number', 'number'],
				[privateKeyContext.GetContext(), 
					UTF8ToCP1251Array(password),
					IntFromBool(exportCerts),
					keyIDs.length,
					trustedKeyIDsPtr.ptr,
					intArrayFromStrings(keyIDs),
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else
			return pPtr.toArray();
	},
	CtxGetCertificateFromPrivateKey: function(
		privateKeyContext, keyID) {
		var pCertInfoExPtr = EUPointer();
		var certArrPtr = EUPointerArray(
			privateKeyContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxGetCertificateFromPrivateKey',
				'number',
				['number', 'array', 
					'number', 'number', 'number'],
				[privateKeyContext.GetContext(), 
					UTF8ToCP1251Array(keyID),
					pCertInfoExPtr.ptr, 
					certArrPtr.ptr, certArrPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pCertInfoExPtr.free();
			certArrPtr.free();

			this.RaiseError(error);
		}

		var certInfoExPtr, certInfoEx;

		certInfoExPtr = pCertInfoExPtr.toPtr();
		certInfoEx = new EndUserCertificateInfoEx(certInfoExPtr);
		Module._EUCtxFreeCertificateInfoEx(
			privateKeyContext.GetContext()|0, certInfoExPtr);

		return new EndUserCertificate(certInfoEx, certArrPtr.toArray());
	},
	CtxChangeOwnCertificatesStatus: function(
		privateKeyContext, requestType, revocationReason) {
		var error;

		try {
			error = Module.ccall('EUCtxChangeOwnCertificatesStatus',
				'number',
				['number', 'number', 'number'],
				[privateKeyContext.GetContext(), 
					requestType, revocationReason]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}
	},
	CtxGetOwnEUserParams: function(privateKeyContext) {
		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUCtxGetOwnEUserParams',
				'number',
				['number', 'number'],
				[privateKeyContext.GetContext(), pPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		var paramsPtr = pPtr.toPtr();
		var info = new EndUserParams(paramsPtr);

		Module._EUCtxFreeEUserParams(
			privateKeyContext.GetContext() | 0, paramsPtr);

		return info;
	},
	CtxModifyOwnEUserParams: function(
		privateKeyContext, phone, email) {
		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUCtxModifyOwnEUserParams',
				'number',
				['number', 'array', 'array'],
				[privateKeyContext.GetContext(),
					UTF8ToCP1251Array(phone), 
					UTF8ToCP1251Array(email)]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}
	},
//-----------------------------------------------------------------------------
	HashData: function(data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var pPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUHashData',
				'number',
				['array', 'number', 'number', 'number', 'number'],
				[data, data.length, 
					asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}
		
		if (asBase64String)
			return pPtr.toString(true);
		else 
			return pPtr.toArray();
	},
	CtxHashData: function(context, hashAlgo, 
		certificate, data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		if (certificate != null)
			this.CheckMaxDataSize(certificate);
		this.CheckMaxDataSize(data);

		var pPtr = EUPointerArray(context.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxHashData',
				'number',
				['number', 'number', 
					certificate != null ? 'array' : 'number', 'number', 
					'array', 'number', 'number', 'number'],
				[context.GetContext(), hashAlgo, 
					(certificate != null) ? certificate : 0,
					(certificate != null) ? certificate.length : 0,
					data, data.length, pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else
			return pPtr.toArray();
	},
	CtxHashDataBegin: function(context, hashAlgo, certificate) {
		if (certificate != null)
			this.CheckMaxDataSize(certificate);

		var hashCtxPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUCtxHashDataBegin',
				'number',
				['number', 'number', 
					certificate != null ? 'array' : 'number', 
					'number', 'number'],
				[context.GetContext(), hashAlgo, 
					(certificate != null) ? certificate : 0,
					(certificate != null) ? certificate.length : 0,
					hashCtxPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			hashCtxPtr.free();
			this.RaiseError(error);
		}

		return EndUserHashContext(hashCtxPtr.toPtr());
	},
	CtxHashDataContinue: function(hashContext, data) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var error;

		try {
			error = Module.ccall('EUCtxHashDataContinue',
				'number',
				['number', 'array', 'number'],
				[hashContext.GetContext(), data, data.length]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}
	},
	CtxHashDataEnd: function(hashContext, asBase64String) {
		var pPtr = EUPointerArray(hashContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxHashDataEnd',
				'number',
				['number', 'number', 'number'],
				[hashContext.GetContext(), pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else
			return pPtr.toArray();
	},
	CtxFreeHash: function(hashContext) {
		try {
			Module._EUCtxFreeHash(hashContext.GetContext()|0);
		} catch (e) {
		}
	},
	CtxHashFile: function(context, hashAlgo, 
		certificate, file, onSuccess, onError, asBase64String) {
		var pThis = this;

		if (certificate != null)
			pThis.CheckMaxDataSize(certificate);

		if (pThis.isFileSyncAPISupported) {
			if (!EUFS.link(file)) {
				setTimeout(function() {
					onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				}, 1);
				return;
			} 

			var pPtr = EUPointerArray(context.GetContext());
			var error;

			try {
				error = Module.ccall('EUCtxHashFile',
					'number',
					['number', 'number', 
						certificate != null ? 'array' : 'number', 'number',
						'array', 'number', 'number'],
					[context.GetContext(), hashAlgo, 
						(certificate != null) ? certificate : 0,
						(certificate != null) ? certificate.length : 0,
						UTF8ToCP1251Array(EUFS.getFilePath(file)),
						pPtr.ptr, pPtr.lengthPtr]);
			} catch (e) {
				error = EU_ERROR_UNKNOWN;
			}

			if (error != EU_ERROR_NONE) {
				EUFS.unlink(file);
				pPtr.free();

				setTimeout(function() {
					onError(pThis.MakeError(error));
				}, 1);
				return;
			}

			EUFS.unlink(file);

			try {
				var data = asBase64String ? 
					pThis.Base64Encode(pPtr.toArray()) : 
					pPtr.toArray();
				setTimeout(function() {
					onSuccess(data);
				}, 1);
			} catch (e) {
				setTimeout(function() {
					onError(e);
				}, 1);
			}
		} else {
			var _onSuccess = function(fileReaded) {
				try {
					var data = pThis.CtxHashData(
						context, hashAlgo, certificate, 
						fileReaded.data, asBase64String);

					onSuccess(data);
				} catch (e) {
					onError(e);
				}
			};

			pThis.ReadFile(file, _onSuccess, onError);
		}
	},
//-----------------------------------------------------------------------------
	CheckDataStruct: function(data) {
		this.CheckMaxDataSize(data);

		if ((typeof data) == 'string')
			data = this.Base64Decode(data);

		var error;

		try {
			error = Module.ccall('EUCheckDataStruct',
				'number',
				['array', 'number'],
				[data, data.length]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);
	},
	CheckFileStruct: function(file, onSuccess, onError) {
		var pThis = this;

		if (pThis.isFileSyncAPISupported) {
			if (!EUFS.link(file)) {
				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			} 

			var error;

			try {
				error = Module.ccall('EUCheckFileStruct',
					'number',
					['array'],
					[UTF8ToCP1251Array(EUFS.getFilePath(file))]);
			} catch (e) {
				error = EU_ERROR_UNKNOWN;
			}

			if (error != EU_ERROR_NONE) {
				EUFS.unlink(file);

				onError(pThis.MakeError(error));
				return;
			}

			EUFS.unlink(file);

			onSuccess();
		} else {
			var _onSuccess = function(fileReaded) {
				try {
					pThis.CheckDataStruct(
						fileReaded.data);
					onSuccess();
				} catch (e) {
					onError(e);
				}
			};

			pThis.ReadFile(file, _onSuccess, onError);
		}
	},
	GetSignType: function(signIndex, sign) {
		this.CheckMaxDataSize(sign);

		var isSignStr = ((typeof sign) == 'string');
		var intPtr = EUPointerDWORD();
		var error;

		try {
			error = Module.ccall('EUGetSignType',
				'number',
				['number', 
					isSignStr ? 'array' : 'number',
					(!isSignStr) ? 'array' : 'number',
					'number', 'number'],
				[signIndex,
					isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0,
					intPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			intPtr.free();

			this.RaiseError(error);
		}

		return intPtr.toNumber();
	},
	IsDataInSignedDataAvailable: function(sign) {
		this.CheckMaxDataSize(sign);

		var isSignStr = ((typeof sign) == 'string');
		var intPtr = EUPointerInt();
		var error;

		try {
			error = Module.ccall('EUIsDataInSignedDataAvailable',
				'number',
				[isSignStr ? 'array' : 'number',
					(!isSignStr) ? 'array' : 'number',
					'number', 'number'],
				[isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0,
					intPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			intPtr.free();
			this.RaiseError(error);
		}

		return intPtr.toBoolean();
	},
	GetDataFromSignedData: function(signedData) {
		this.CheckMaxDataSize(signedData);

		var isSignStr = ((typeof signedData) == 'string');
		var arrPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUGetDataFromSignedData',
				'number',
				[isSignStr ? 'array' : 'number',
					(!isSignStr) ? 'array' : 'number',
					'number', 'number', 'number'],
				[isSignStr ? StringToCString(signedData) : 0,
					!isSignStr ? signedData : 0,
					!isSignStr ? signedData.length : 0, 
					arrPtr.ptr, arrPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			arrPtr.free();
			this.RaiseError(error);
		}

		return arrPtr.toArray();
	},
	GetSignTimeInfo: function(signIndex, sign) {
		this.CheckMaxDataSize(sign);

		var isSignStr = ((typeof sign) == 'string');
		var pTimeInfoPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUGetSignTimeInfo',
				'number',
				['number', 
					isSignStr ? 'array' : 'number',
					(!isSignStr) ? 'array' : 'number',
					'number', 'number'],
				[signIndex,
					isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0,
					pTimeInfoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pTimeInfoPtr.free();

			this.RaiseError(error);
		}

		var timeInfoPtr, timeInfo;

		timeInfoPtr = pTimeInfoPtr.toPtr();
		timeInfo = new EndUserTimeInfo(timeInfoPtr);
		Module._EUFreeTimeInfo(timeInfoPtr);

		return timeInfo;
	},
	GetFileSignTimeInfo: function(signIndex, signedFile, 
		onSuccess, onError) {
		var pThis = this;

		if (pThis.isFileSyncAPISupported) {
			try {
				var timeInfo = pThis._GetFileSignTimeInfoSync(
					signIndex, signedFile);
				onSuccess(timeInfo);
				return;
			} catch (e) {
				onError(e);
				return;
			}
		} else {
			var _onSuccess = function(fileReaded) {
				try {
					var signTimeInfo = pThis.GetSignTimeInfo(
						signIndex, fileReaded.data);
					onSuccess(signTimeInfo);
				} catch (e) {
					onError(e);
				}
			};

			pThis.ReadFile(signedFile, _onSuccess, onError);
		}
	},
	SignData: function(data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var pPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUSignData',
				'number',
				['array', 'number', 'number', 'number', 'number'],
				[data, data.length, 
					asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return pPtr.toString(true);
		else 
			return pPtr.toArray();
	},
	VerifyData: function(data, sign) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckDataStruct(sign);

		this.CheckMaxDataSize(data);
		this.CheckMaxDataSize(sign);

		var isSignStr = ((typeof sign) == 'string');
		var infoPtr = EUPointerSignerInfo();
		var signTimeInfo = null;
		var error;

		try {
			error = Module.ccall('EUVerifyData',
				'number',
				['array', 'number', 
					isSignStr ? 'array' : 'number',
					(!isSignStr) ? 'array' : 'number',
					'number', 'number'],
				[data, data.length,
					isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0,
					infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		try {
			signTimeInfo = this.GetSignTimeInfo(0, sign);
		} catch (e) {
			infoPtr.free();
			throw e;
		}
		
		var info = new EndUserSignInfo(infoPtr.ptr, 
			data, signTimeInfo);
		infoPtr.free();

		return info;
	},
	VerifyDataOnTimeEx: function(data, signIndex, sign, 
		onTime, offline, noCRL) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckDataStruct(sign);

		this.CheckMaxDataSize(data);
		this.CheckMaxDataSize(sign);

		var isSignStr = ((typeof sign) == 'string');
		var onTimePtr = (onTime != null) ? 
			EUPointerSystemtime(onTime) : 0;
		var infoPtr = EUPointerSignerInfo();
		var signTimeInfo = null;
		var error;

		try {
			error = Module.ccall('EUVerifyDataOnTimeEx',
				'number',
				['array', 'number', 'number',
					isSignStr ? 'array' : 'number',
					!isSignStr ? 'array' : 'number', 'number',
					'number', 'number', 'number', 'number'],
				[data, data.length, signIndex,
					isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0,
					(onTime != null) ? onTimePtr.ptr : 0, 
					IntFromBool(offline), IntFromBool(noCRL),
					infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (onTime != null)
			onTimePtr.free();

		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		try {
			signTimeInfo = this.GetSignTimeInfo(signIndex, sign);
		} catch (e) {
			infoPtr.free();
			throw e;
		}
		
		var info = new EndUserSignInfo(infoPtr.ptr, 
			data, signTimeInfo);
		infoPtr.free();

		return info;
	},
	SignDataInternal: function(appendCert, data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var pPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUSignDataInternal',
				'number',
				['number', 'array', 'number', 
					'number', 'number', 'number'],
				[IntFromBool(appendCert),
					data, data.length, 
					asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return pPtr.toString(true);
		else 
			return pPtr.toArray();
	},
	VerifyDataInternal: function(sign) {
		this.CheckMaxDataSize(sign);

		this.CheckDataStruct(sign);

		var isSignStr = ((typeof sign) == 'string');
		var infoPtr = EUPointerSignerInfo();
		var arrPtr = EUPointerArray();
		var signTimeInfo = null;
		var error;

		try {
			error = Module.ccall('EUVerifyDataInternal',
				'number',
				[isSignStr ? 'array' : 'number',
					(!isSignStr) ? 'array' : 'number',
					'number', 'number', 'number', 'number'],
				[isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0, 
					arrPtr.ptr, arrPtr.lengthPtr, infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			arrPtr.free();
			this.RaiseError(error);
		}

		try {
			signTimeInfo = this.GetSignTimeInfo(0, sign);
		} catch (e) {
			infoPtr.free();
			arrPtr.free();
			throw e;
		}

		var info = new EndUserSignInfo(infoPtr.ptr, 
			arrPtr.toArray(), signTimeInfo);
		infoPtr.free();

		return info;
	},
	VerifyDataInternalOnTimeEx: function(signIndex, sign,
		onTime, offline, noCRL) {
		this.CheckMaxDataSize(sign);

		this.CheckDataStruct(sign);

		var isSignStr = ((typeof sign) == 'string');
		var onTimePtr = (onTime != null) ? 
			EUPointerSystemtime(onTime) : 0;
		var infoPtr = EUPointerSignerInfo();
		var arrPtr = EUPointerArray();
		var signTimeInfo = null;
		var error;

		try {
			error = Module.ccall('EUVerifyDataInternalOnTimeEx',
				'number',
				['number', 
					isSignStr ? 'array' : 'number',
					(!isSignStr) ? 'array' : 'number', 'number',
					'number', 'number', 'number',
					'number', 'number', 'number'],
				[signIndex, isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0, 
					(onTime != null) ? onTimePtr.ptr : 0,
					IntFromBool(offline), IntFromBool(noCRL),
					arrPtr.ptr, arrPtr.lengthPtr, infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (onTime != null)
			onTimePtr.free();

		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			arrPtr.free();
			this.RaiseError(error);
		}
		
		try {
			signTimeInfo = this.GetSignTimeInfo(signIndex, sign);
		} catch (e) {
			infoPtr.free();
			arrPtr.free();
			throw e;
		}

		var info = new EndUserSignInfo(infoPtr.ptr, 
			arrPtr.toArray(), signTimeInfo);
		infoPtr.free();

		return info;
	},
	SignHash: function (hash, asBase64String) {
		this.CheckMaxDataSize(hash);

		var isHashStr = ((typeof hash) == 'string');
		var pPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUSignHash',
				'number',
				[isHashStr ? 'array' : 'number',
					!isHashStr ? 'array' : 'number', 'number', 
					'number', 'number', 'number'],
				[isHashStr ? StringToCString(hash) : 0, 
					!isHashStr ? hash : 0, 
					!isHashStr ? hash.length : 0, 
					asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return pPtr.toString(true);
		else 
			return pPtr.toArray();
	},
	VerifyHash: function (hash, sign) {
		this.CheckMaxDataSize(hash);
		this.CheckMaxDataSize(sign);

		this.CheckDataStruct(sign);

		var isHashStr = ((typeof hash) == 'string');
		var isSignStr = ((typeof sign) == 'string');
		var infoPtr = EUPointerSignerInfo();
		var signTimeInfo = null;
		var error;

		try {
			error = Module.ccall('EUVerifyHash',
				'number',
				[isHashStr ? 'array' : 'number',
					!isHashStr ? 'array' : 'number', 'number',
					isSignStr ? 'array' : 'number',
					!isSignStr ? 'array' : 'number',
					'number', 'number'],
				[isHashStr ? StringToCString(hash) : 0, 
					!isHashStr ? hash : 0, 
					!isHashStr ? hash.length : 0,
					isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0,
					infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		try {
			signTimeInfo = this.GetSignTimeInfo(0, sign);
		} catch (e) {
			infoPtr.free();
			throw e;
		}

		var info = new EndUserSignInfo(infoPtr.ptr, 
			null, signTimeInfo);
		infoPtr.free();

		return info;
	},
	VerifyHashOnTimeEx: function (hash, signIndex, sign, 
		onTime, offline, noCRL) {
		this.CheckMaxDataSize(hash);
		this.CheckMaxDataSize(sign);

		this.CheckDataStruct(sign);
		
		var isHashStr = ((typeof hash) == 'string');
		var isSignStr = ((typeof sign) == 'string');
		var infoPtr = EUPointerSignerInfo();
		var onTimePtr = (onTime != null) ? 
			EUPointerSystemtime(onTime) : 0;
		var signTimeInfo = null;
		var error;

		try {
			error = Module.ccall('EUVerifyHashOnTimeEx',
				'number',
				[isHashStr ? 'array' : 'number',
					!isHashStr ? 'array' : 'number', 'number',
					'number',
					isSignStr ? 'array' : 'number',
					!isSignStr ? 'array' : 'number', 'number', 
					'number', 'number', 'number', 'number'],
				[isHashStr ? StringToCString(hash) : 0, 
					!isHashStr ? hash : 0, 
					!isHashStr ? hash.length : 0,
					signIndex,
					isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0,
					(onTime != null) ? onTimePtr.ptr : 0,
					IntFromBool(offline), IntFromBool(noCRL),
					infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (onTime != null)
			onTimePtr.free();

		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		try {
			signTimeInfo = this.GetSignTimeInfo(signIndex, sign);
		} catch (e) {
			infoPtr.free();
			throw e;
		}

		var info = new EndUserSignInfo(infoPtr.ptr, 
			null, signTimeInfo);
		infoPtr.free();

		return info;
	},
	SignHashRSA: function (hash, asBase64String) {
		this.CheckMaxDataSize(hash);

		var isHashStr = ((typeof hash) == 'string');
		var pPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUSignHashRSA',
				'number',
				[isHashStr ? 'array' : 'number',
					!isHashStr ? 'array' : 'number', 'number', 
					'number', 'number', 'number'],
				[isHashStr ? StringToCString(hash) : 0, 
					!isHashStr ? hash : 0, 
					!isHashStr ? hash.length : 0, 
					asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return pPtr.toString(true);
		else 
			return pPtr.toArray();
	},
	SignDataRSA: function(data, appendCert, 
		externalSgn, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var pPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUSignDataRSA',
				'number',
				['array', 'number', 'number', 'number', 
					'number', 'number', 'number'],
				[data, data.length, 
					IntFromBool(appendCert),
					IntFromBool(externalSgn),
					asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return pPtr.toString(true);
		else 
			return pPtr.toArray();
	},
	IsDataInSignedFileAvailable: function(signedFile, onSuccess, onError) {
		var pThis = this;

		if (pThis.isFileSyncAPISupported) {
			if (!EUFS.link(signedFile)) {
				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			}

			var intPtr = EUPointerInt();
			var error;

			try {
				error = Module.ccall('EUIsDataInSignedFileAvailable',
					'number',
					['array', 'number'],
					[UTF8ToCP1251Array(EUFS.getFilePath(signedFile)),
						intPtr.ptr]);
			} catch (e) {
				error = EU_ERROR_UNKNOWN;
			}

			if (error != EU_ERROR_NONE) {
				intPtr.free();
				EUFS.unlink(signedFile);

				onError(pThis.MakeError(error));
				return;
			}

			EUFS.unlink(signedFile);

			onSuccess(intPtr.toBoolean());
		} else {
			var _onSuccess = function(fileReaded) {
				try {
					var isAvailable = pThis.IsDataInSignedDataAvailable(
						fileReaded.data);
					onSuccess(isAvailable);
				} catch (e) {
					onError(e);
				}
			};

			pThis.ReadFile(signedFile, _onSuccess, onError);
		}
	},
	GetDataFromSignedFile: function(signedFile, onSuccess, onError) {
		var pThis = this;

		if (pThis.isFileSyncAPISupported) {
			var file = signedFile.name + MakeUID(10);

			if (!EUFS.link(signedFile)) {
				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			} 

			if (!EUFS.link(file)) {
				EUFS.unlink(signedFile);

				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			} 

			var error;

			try {
				error = Module.ccall('EUGetDataFromSignedFile',
					'number',
					['array', 'array'],
					[UTF8ToCP1251Array(EUFS.getFilePath(signedFile)),
						UTF8ToCP1251Array(EUFS.getFilePath(file))]);
			} catch (e) {
				error = EU_ERROR_UNKNOWN;
			}

			if (error != EU_ERROR_NONE) {
				EUFS.unlink(file);
				EUFS.unlink(signedFile);

				onError(pThis.MakeError(error));
				return;
			}

			var data = EUFS.readFileAsUint8Array(file);

			EUFS.unlink(file);
			EUFS.unlink(signedFile);

			onSuccess(data);
		} else {
			var _onSuccess = function(fileReaded) {
				try {
					var data = pThis.GetDataFromSignedData(
						fileReaded.data);

					onSuccess(data);
				} catch (e) {
					onError(e);
				}
			};

			pThis.ReadFile(signedFile, _onSuccess, onError);
		}
	},
	VerifyFileWithExternalSign: function(file, fileWithSign, onSuccess, onError) {
		var pThis = this;

		if (pThis.isFileSyncAPISupported) {
			if (!EUFS.link(file)) {
				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			}

			if (!EUFS.link(fileWithSign)) {
				EUFS.unlink(file);

				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			}

			var infoPtr = EUPointerSignerInfo();
			var timeInfo = null;
			var error;

			try {
				error = Module.ccall('EUCheckFileStruct',
					'number',
					['array'],
					[UTF8ToCP1251Array(EUFS.getFilePath(fileWithSign))]);
				if (error == EU_ERROR_NONE) {
					error = Module.ccall('EUVerifyFile',
						'number',
						['array', 'array', 'number'],
						[UTF8ToCP1251Array(EUFS.getFilePath(fileWithSign)), 
							UTF8ToCP1251Array(EUFS.getFilePath(file)), infoPtr.ptr]);
				}
			} catch (e) {
				error = EU_ERROR_UNKNOWN;
			}

			if (error != EU_ERROR_NONE) {
				EUFS.unlink(fileWithSign);
				EUFS.unlink(file);

				onError(pThis.MakeError(error));
				return;
			}

			EUFS.unlink(fileWithSign);
			EUFS.unlink(file);

			try {
				timeInfo = pThis._GetFileSignTimeInfoSync(
					0, fileWithSign);
			} catch (e) {
				onError(e);
				return;
			}

			var info = new EndUserSignInfo(infoPtr.ptr, 
				null, timeInfo);
			infoPtr.free();

			onSuccess(info);
		} else {
			var _onSuccess= function(files) {
				try {
					var info = pThis.VerifyData(
						files[0].data, files[1].data);
					info.data = null;

					onSuccess(info);
				} catch (e) {
					onError(e);
				}
			};

			pThis.ReadFiles([file, fileWithSign], 
				_onSuccess, onError);
		}
	},
	VerifyFileWithInternalSign: function(signedFile, dataFile, onSuccess, onError) {
		var pThis = this;

		if (pThis.isFileSyncAPISupported) {
			var file;

			file = (dataFile != null) ? 
				dataFile : 
				(signedFile.name + MakeUID(10));

			if (!EUFS.link(file, (dataFile == null))) {
				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			}

			if (!EUFS.link(signedFile)) {
				EUFS.unlink(file);

				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			}

			var infoPtr = EUPointerSignerInfo();
			var timeInfo;
			var error;

			try {
				error = Module.ccall('EUCheckFileStruct',
					'number',
					['array'],
					[UTF8ToCP1251Array(EUFS.getFilePath(signedFile))]);
				if (error == EU_ERROR_NONE) {
					error = Module.ccall('EUVerifyFile',
						'number',
						['array', 'array', 'number'],
						[UTF8ToCP1251Array(EUFS.getFilePath(signedFile)),
							UTF8ToCP1251Array(EUFS.getFilePath(file)),
							infoPtr.ptr]);
				}
			} catch (e) {
				error = EU_ERROR_UNKNOWN;
			}

			if (error != EU_ERROR_NONE) {
				EUFS.unlink(signedFile);
				EUFS.unlink(file);

				onError(pThis.MakeError(error));
				return;
			}

			var data = (dataFile != null) ?
				EUFS.readFileAsUint8Array(file) :
				null;

			EUFS.unlink(file);
			EUFS.unlink(signedFile);

			try {
				timeInfo = pThis._GetFileSignTimeInfoSync(
					0, signedFile);
			} catch (e) {
				onError(e);
				return;
			}

			var info = new EndUserSignInfo(infoPtr.ptr, 
				data, timeInfo);
			infoPtr.free();

			onSuccess(info);
		} else {
			var _onSuccess = function(fileReaded) {
				try {
					var info = pThis.VerifyDataInternal(fileReaded.data);
					
					if (dataFile == null)
						info.data = null;

					onSuccess(info);
				} catch (e) {
					onError(e);
				}
			};

			pThis.ReadFile(signedFile, _onSuccess, onError);
		}
	},
	CreateEmptySign: function (data, asBase64String) {
		var isInternalSign = (data != null);
		if (isInternalSign)
			this.CheckMaxDataSize(data);
		if (isInternalSign) {
			if ((typeof data) == 'string')
				data = this.StringToArray(data);
		}

		var signPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUCreateEmptySign',
				'number',
				[isInternalSign ? 'array' : 'number', 'number',
					'number', 'number', 'number'],
				[isInternalSign ? data : 0, 
					isInternalSign ? data.length : 0,
					asBase64String ? signPtr.ptr : 0,
					!asBase64String ? signPtr.ptr : 0,
					!asBase64String ? signPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			signPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return signPtr.toString(true);
		else
			return signPtr.toArray();
	},
	CreateSigner: function (hash, asBase64String) {
		this.CheckMaxDataSize(hash);

		var isHashStr = ((typeof hash) == 'string');
		var signerPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUCreateSigner',
				'number',
				[isHashStr ? 'array' : 'number', 
					!isHashStr ? 'array' : 'number', 'number',
					'number', 'number', 'number'],
				[isHashStr ? StringToCString(hash) : 0, 
					!isHashStr ? hash : 0,
					!isHashStr ? hash.length : 0,
					asBase64String ? signerPtr.ptr : 0,
					!asBase64String ? signerPtr.ptr : 0,
					!asBase64String ? signerPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			signerPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return signerPtr.toString(true);
		else
			return signerPtr.toArray();
	},
	AppendSigner: function (signer, certificate, prevSign, asBase64String) {
		this.CheckMaxDataSize(signer);
		if (certificate != null)
			this.CheckMaxDataSize(certificate);
		this.CheckMaxDataSize(prevSign);

		var isSignerStr = ((typeof signer) == 'string');
		var isPrevSignStr = ((typeof prevSign) == 'string');
		var signPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUAppendSigner',
				'number',
				[isSignerStr ? 'array' : 'number',
					!isSignerStr ? 'array' : 'number', 'number',
					certificate != null ? 'array' : 'number', 'number',
					isPrevSignStr ? 'array' : 'number', 
					!isPrevSignStr ? 'array' : 'numer', 'number',
					'number', 'number', 'number'],
				[isSignerStr ? StringToCString(signer) : 0, 
					!isSignerStr ? signer : 0,
					!isSignerStr ? signer.length : 0,
					(certificate != null) ? certificate : 0,
					(certificate != null) ? certificate.length : 0,
					isPrevSignStr ? StringToCString(prevSign) : 0, 
					!isPrevSignStr ? prevSign : 0,
					!isPrevSignStr ? prevSign.length : 0,
					asBase64String ? signPtr.ptr : 0,
					!asBase64String ? signPtr.ptr : 0,
					!asBase64String ? signPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			signPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return signPtr.toString(true);
		else
			return signPtr.toArray();
	},
	GetSigner: function(signIndex, sign, asBase64String) {
		this.CheckMaxDataSize(sign);

		var isSignStr = ((typeof sign) == 'string');
		var signerPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUGetSigner',
				'number',
				['number', 
					isSignStr ? 'array' : 'number', 
					!isSignStr ? 'array' : 'number', 'number',
					'number', 'number', 'number'],
				[signIndex, 
					isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0,
					asBase64String ? signerPtr.ptr : 0,
					!asBase64String ? signerPtr.ptr : 0,
					!asBase64String ? signerPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			signerPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return signerPtr.toString(true);
		else
			return signerPtr.toArray();
	},
	AppendValidationDataToSigner: function (prevSigner, certificate, asBase64String) {
		this.CheckMaxDataSize(prevSigner);
		if (certificate != null)
			this.CheckMaxDataSize(certificate);

		var isPrevSignerStr = ((typeof prevSigner) == 'string');
		var signerPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUAppendValidationDataToSigner',
				'number',
				[isPrevSignerStr ? 'array' : 'number',
					!isPrevSignerStr ? 'array' : 'number', 'number',
					certificate != null ? 'array' : 'number', 'number', 
					'number', 'number', 'number'],
				[isPrevSignerStr ? StringToCString(prevSigner) : 0, 
					!isPrevSignerStr ? prevSigner : 0,
					!isPrevSignerStr ? prevSigner.length : 0,
					(certificate != null) ? certificate : 0,
					(certificate != null) ? certificate.length : 0,
					asBase64String ? signerPtr.ptr : 0,
					!asBase64String ? signerPtr.ptr : 0,
					!asBase64String ? signerPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			signerPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return signerPtr.toString(true);
		else
			return signerPtr.toArray();
	},
	RawSignData: function(data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var pPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EURawSignData',
				'number',
				['array', 'number', 'number', 'number', 'number'],
				[data, data.length, 
					asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return pPtr.toString(true);
		else 
			return pPtr.toArray();
	},
	RawVerifyDataEx: function(cert, data, sign) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		if (cert != null)
			this.CheckMaxDataSize(cert);

		this.CheckMaxDataSize(data);
		this.CheckMaxDataSize(sign);

		var isSignStr = ((typeof sign) == 'string');
		var infoPtr = EUPointerSignerInfo();
		var error;

		try {
			error = Module.ccall('EURawVerifyDataEx',
				'number',
				[cert ? 'array' : 'numer', 'number',
					'array', 'number', 
					isSignStr ? 'array' : 'number',
					!isSignStr ? 'array' : 'number',
					'number', 'number'],
				[(cert != null) ? cert : 0,
					(cert != null) ? cert.length : 0, 
					data, data.length,
					isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0,
					infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		var info = new EndUserSignInfo(infoPtr.ptr, data);
		infoPtr.free();

		return info;
	},
	RawSignHash: function (hash, asBase64String) {
		this.CheckMaxDataSize(hash);

		var isHashStr = ((typeof hash) == 'string');
		var pPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EURawSignHash',
				'number',
				[isHashStr ? 'array' : 'number',
					!isHashStr ? 'array' : 'number', 'number', 
					'number', 'number', 'number'],
				[isHashStr ? StringToCString(hash) : 0, 
					!isHashStr ? hash : 0, 
					!isHashStr ? hash.length : 0, 
					asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return pPtr.toString(true);
		else 
			return pPtr.toArray();
	},
	RawVerifyHash: function (hash, sign) {
		this.CheckMaxDataSize(hash);
		this.CheckMaxDataSize(sign);

		var isHashStr = ((typeof hash) == 'string');
		var isSignStr = ((typeof sign) == 'string');
		var infoPtr = EUPointerSignerInfo();
		var error;

		try {
			error = Module.ccall('EURawVerifyHash',
				'number',
				[isHashStr ? 'array' : 'number',
					!isHashStr ? 'array' : 'number', 'number',
					isSignStr ? 'array' : 'number', 
					!isSignStr ? 'array' : 'number', 'number', 'number'],
				[isHashStr ? StringToCString(hash) : 0, 
					!isHashStr ? hash : 0, 
					!isHashStr ? hash.length : 0,
					isSignStr ? StringToCString(sign) : 0,
					!isSignStr ? sign : 0,
					!isSignStr ? sign.length : 0,
					infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		var info = new EndUserSignInfo(infoPtr.ptr, null);
		infoPtr.free();

		return info;
	},
	CtxSignHash: function (privateKeyContext, signAlgo, 
		hashContext, appendCert, asBase64String) {
		var pPtr = EUPointerArray(
			privateKeyContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxSignHash',
				'number',
				['number', 'number', 'number', 'number',
					'number', 'number'],
				[privateKeyContext.GetContext(), signAlgo,
					hashContext.GetContext(), 
					IntFromBool(appendCert),
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxVerifyHash: function (hashContext, signIndex, sign) {
		this.CheckDataStruct(sign);

		this.CheckMaxDataSize(sign);

		if ((typeof sign) == 'string')
			sign = this.Base64Decode(sign);

		var infoPtr = EUPointerSignerInfo(
			hashContext.GetContext());
		var signTimeInfo = null;
		var error;

		try {
			error = Module.ccall('EUCtxVerifyHash',
				'number',
				['number', 'number', 'array', 'number', 'number'],
				[hashContext.GetContext(), signIndex,
					sign, sign.length, infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		try {
			signTimeInfo = this.GetSignTimeInfo(signIndex, sign);
		} catch (e) {
			infoPtr.free();
			throw e;
		}
		
		var info = new EndUserSignInfo(infoPtr.ptr, 
			null, signTimeInfo);
		infoPtr.free();

		return info;
	},
	CtxSignHashValue: function (privateKeyContext, signAlgo, 
		hash, appendCert, asBase64String) {
		if ((typeof hash) == 'string')
			hash = this.Base64Decode(hash);

		var pPtr = EUPointerArray(
			privateKeyContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxSignHashValue',
				'number',
				['number', 'number', 'array', 'number', 'number',
					'number', 'number'],
				[privateKeyContext.GetContext(), signAlgo,
					hash, hash.length, IntFromBool(appendCert),
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxVerifyHashValue: function (context, hash, signIndex, sign) {
		this.CheckDataStruct(sign);
		
		this.CheckMaxDataSize(hash);
		this.CheckMaxDataSize(sign);

		if ((typeof hash) == 'string')
			hash = this.Base64Decode(hash);

		if ((typeof sign) == 'string')
			sign = this.Base64Decode(sign);

		var infoPtr = EUPointerSignerInfo(context.GetContext());
		var signTimeInfo = null;
		var error;

		try {
			error = Module.ccall('EUCtxVerifyHashValue',
				'number',
				['number', 'array', 'number', 'number',
					'array', 'number', 'number'],
				[context.GetContext(), hash, hash.length, signIndex,
					sign, sign.length, infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		try {
			signTimeInfo = this.GetSignTimeInfo(signIndex, sign);
		} catch (e) {
			infoPtr.free();
			throw e;
		}
		
		var info = new EndUserSignInfo(infoPtr.ptr, 
			null, signTimeInfo);
		infoPtr.free();

		return info;
	},
	CtxSignData: function(privateKeyContext, signAlgo, 
		data, external, appendCert, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var pPtr = EUPointer(
			privateKeyContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxSignData',
				'number',
				['number', 'number', 'array', 'number',
					'number', 'number', 'number', 'number'],
				[privateKeyContext.GetContext(), signAlgo,
					data, data.length, IntFromBool(external),
					IntFromBool(appendCert),
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxVerifyData: function(context, data, signIndex, sign) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckDataStruct(sign);

		this.CheckMaxDataSize(data);
		this.CheckMaxDataSize(sign);

		if ((typeof sign) == 'string')
			sign = this.Base64Decode(sign);

		var infoPtr = EUPointerSignerInfo(context.GetContext());
		var signTimeInfo = null;
		var error;

		try {
			error = Module.ccall('EUCtxVerifyData',
				'number',
				['number', 'array', 'number', 
					'number', 'array', 'number', 'number'],
				[context.GetContext(), data, data.length,
					signIndex, sign, sign.length,
					infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		try {
			signTimeInfo = this.GetSignTimeInfo(signIndex, sign);
		} catch (e) {
			infoPtr.free();
			throw e;
		}
		
		var info = new EndUserSignInfo(infoPtr.ptr, 
			data, signTimeInfo);
		infoPtr.free();

		return info;
	},
	CtxVerifyDataInternal: function(context, signIndex, sign) {
		this.CheckMaxDataSize(sign);

		if ((typeof sign) == 'string')
			sign = this.Base64Decode(sign);

		this.CheckDataStruct(sign);

		var arrPtr = EUPointerArray(context.GetContext());
		var infoPtr = EUPointerSignerInfo(context.GetContext());
		var signTimeInfo = null;
		var error;

		try {
			error = Module.ccall('EUCtxVerifyDataInternal',
				'number',
				['number', 'number', 'array', 'number',
					'number', 'number', 'number'],
				[context.GetContext(), signIndex, sign, sign.length,
					arrPtr.ptr, arrPtr.lengthPtr, infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			arrPtr.free();
			infoPtr.free();
			this.RaiseError(error);
		}

		try {
			signTimeInfo = this.GetSignTimeInfo(signIndex, sign);
		} catch (e) {
			arrPtr.free();
			infoPtr.free();
			throw e;
		}
		
		var info = new EndUserSignInfo(infoPtr.ptr, 
			arrPtr.toArray(), signTimeInfo);
		infoPtr.free();

		return info;
	},
	CtxSignFile: function(privateKeyContext, signAlgo, 
		file, external, appendCert, fileWithSign, 
		onSuccess, onError) {
		var pThis = this;

		if (pThis.isFileSyncAPISupported) {
			var signFile;

			signFile = (fileWithSign != null) ? 
				fileWithSign : 
				(file.name + MakeUID(10));

			if (!EUFS.link(signFile, (signFile == null))) {
				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			}

			if (!EUFS.link(file)) {
				EUFS.unlink(signFile);

				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			}

			var error;

			try {
				error = Module.ccall('EUCtxSignFile',
					'number',
					['number', 'number', 'array', 
						'number', 'number', 'array'],
					[privateKeyContext.GetContext(), signAlgo,
						UTF8ToCP1251Array(EUFS.getFilePath(file)),
						IntFromBool(external), IntFromBool(appendCert),
						UTF8ToCP1251Array(EUFS.getFilePath(signFile))]);
			} catch (e) {
				error = EU_ERROR_UNKNOWN;
			}

			if (error != EU_ERROR_NONE) {
				EUFS.unlink(file);
				EUFS.unlink(signFile);

				onError(pThis.MakeError(error));
				return;
			}

			var sign = (file != null) ?
				EUFS.readFileAsUint8Array(signFile) :
				null;

			EUFS.unlink(signFile);
			EUFS.unlink(file);

			onSuccess(sign);
		} else {
			var _onSuccess = function(fileReaded) {
				try {
					var signedData; 

					signedData = pThis.CtxSignData(
						privateKeyContext, signAlgo, 
						fileReaded.data, external, appendCert);

					onSuccess(signedData);
				} catch (e) {
					onError(e);
				}
			};

			pThis.ReadFile(file, _onSuccess, onError);
		}
	},
	CtxIsAlreadySigned: function(privateKeyContext, signAlgo, sign) {
		this.CheckMaxDataSize(sign);

		if ((typeof sign) == 'string')
			sign = this.Base64Decode(sign);

		var intPtr = EUPointerInt();
		var error;

		try {
			error = Module.ccall('EUCtxIsAlreadySigned',
				'number',
				['number', 'number', 'array', 'number', 'number'],
				[privateKeyContext.GetContext(), signAlgo,
					sign, sign.length, intPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			intPtr.free();
			this.RaiseError(error);
		}

		return intPtr.toBoolean();
	},
	CtxAppendSignHash: function (privateKeyContext, signAlgo, 
		hashContext, previousSign, appendCert, asBase64String) {
		this.CheckMaxDataSize(previousSign);

		if ((typeof previousSign) == 'string')
			previousSign = this.Base64Decode(previousSign);

		this.CheckDataStruct(previousSign);

		var pPtr = EUPointerArray(
			privateKeyContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxAppendSignHash',
				'number',
				['number', 'number', 'number', 'array', 'number',
					'number', 'number', 'number'],
				[privateKeyContext.GetContext(), signAlgo,
					hashContext.GetContext(),
					previousSign, previousSign.length,
					IntFromBool(appendCert),
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxAppendSignHashValue: function (privateKeyContext, signAlgo, 
		hash, previousSign, appendCert, asBase64String) {
		this.CheckMaxDataSize(hash);
		this.CheckMaxDataSize(previousSign);

		if ((typeof hash) == 'string')
			hash = this.Base64Decode(hash);

		if ((typeof previousSign) == 'string')
			previousSign = this.Base64Decode(previousSign);

		this.CheckDataStruct(previousSign);

		var pPtr = EUPointerArray(privateKeyContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxAppendSignHashValue',
				'number',
				['number', 'number', 'array', 'number', 
					'array', 'number', 'number', 'number', 'number'],
				[privateKeyContext.GetContext(), signAlgo,
					hash, hash.length, 
					previousSign, previousSign.length, 
					IntFromBool(appendCert),
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxAppendSign: function(privateKeyContext, signAlgo, 
		data, previousSign, appendCert, asBase64String) {
		if ((data != null) && (typeof data) == 'string')
			data = this.StringToArray(data);

		if (data != null)
			this.CheckMaxDataSize(data);
		this.CheckMaxDataSize(previousSign);

		if ((typeof previousSign) == 'string')
			previousSign = this.Base64Decode(previousSign);

		this.CheckDataStruct(previousSign);

		var pPtr = EUPointer(privateKeyContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxAppendSign',
				'number',
				['number', 'number', 
					data ? 'array' : 'number', 'number',
					'array', 'number', 'number', 'number', 'number'],
				[privateKeyContext.GetContext(), signAlgo,
					(data != null) ? data : 0,
					(data != null) ? data.length : 0,
					previousSign, previousSign.length,
					IntFromBool(appendCert),
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxCreateEmptySign: function(context, signAlgo, 
		data, certificate, asBase64String) {
		if ((data != null) && (typeof data) == 'string')
			data = this.StringToArray(data);

		if (data != null)
			this.CheckMaxDataSize(data);
		this.CheckMaxDataSize(certificate);

		var pPtr = EUPointer(context.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxCreateEmptySign',
				'number',
				['number', 'number', 
					data ? 'array' : 'number', 'number',
					'array', 'number', 'number', 'number'],
				[context.GetContext(), signAlgo,
					(data != null) ? data : 0,
					(data != null) ? data.length : 0,
					certificate, certificate.length,
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxCreateSigner: function(privateKeyContext, signAlgo, 
		hash, asBase64String) {
		this.CheckMaxDataSize(hash);

		if ((typeof hash) == 'string')
			hash = this.Base64Decode(hash);

		var pPtr = EUPointer(privateKeyContext.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxCreateSigner',
				'number',
				['number', 'number', 'array', 'number',
					'number', 'number'],
				[privateKeyContext.GetContext(), signAlgo,
					hash, hash.length,
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxAppendSigner: function(context, signAlgo, 
		signer, certificate, previousSign, asBase64String) {
		this.CheckMaxDataSize(signer);
		if (certificate != null)
			this.CheckMaxDataSize(certificate);
		this.CheckMaxDataSize(previousSign);

		if ((typeof signer) == 'string')
			signer = this.Base64Decode(signer);

		if ((typeof previousSign) == 'string')
			previousSign = this.Base64Decode(previousSign);

		var pPtr = EUPointer(context.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxAppendSigner',
				'number',
				['number', 'number', 'array', 'number',
					certificate != null ? 'array' : 'number',
					'number', 'array', 'number',
					'number', 'number'],
				[context.GetContext(), signAlgo,
					signer, signer.length,
					(certificate != null) ? certificate : 0,
					(certificate != null) ? certificate.length : 0,
					previousSign, previousSign.length,
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxGetSignsCount: function(context, sign) {
		this.CheckMaxDataSize(sign);

		if ((typeof sign) == 'string')
			sign = this.Base64Decode(sign);

		var intPtr = EUPointerDWORD();
		var error;

		try {
			error = Module.ccall('EUCtxGetSignsCount',
				'number',
				['number', 'array', 'number', 'number'],
				[context.GetContext(), sign, sign.length,
					intPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			intPtr.free();
			this.RaiseError(error);
		}

		return intPtr.toNumber();
	},
	CtxGetSignerInfo: function(context, signIndex, sign) {
		this.CheckMaxDataSize(sign);

		if ((typeof sign) == 'string')
			sign = this.Base64Decode(sign);

		var pCertInfoExPtr = EUPointer();
		var certArrPtr = EUPointerArray(context.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxGetSignerInfo',
				'number',
				['number', 'number', 'array', 'number',
					'number', 'number', 'number'],
				[context.GetContext(), signIndex, sign, sign.length,
					pCertInfoExPtr.ptr, 
					certArrPtr.ptr, certArrPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pCertInfoExPtr.free();
			certArrPtr.free();

			this.RaiseError(error);
		}

		var certInfoExPtr, certInfoEx;

		certInfoExPtr = pCertInfoExPtr.toPtr();
		certInfoEx = new EndUserCertificateInfoEx(certInfoExPtr);
		Module._EUCtxFreeCertificateInfoEx(
			context.GetContext()|0, certInfoExPtr);

		return new EndUserCertificate(certInfoEx, certArrPtr.toArray());
	},
	CtxGetFileSignsCount: function(context, signFile, 
		onSuccess, onError) {
		var pThis = this;

		if (pThis.isFileSyncAPISupported) {
			if (!EUFS.link(signFile)) {
				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			}

			var intPtr = EUPointerDWORD();
			var error;
			try {
				error = Module.ccall('EUCtxGetFileSignsCount',
					'number',
					['number',
						'array', 'number'],
					[context.GetContext(),  
						UTF8ToCP1251Array(EUFS.getFilePath(signFile)),
						intPtr.ptr]);
			} catch (e) {
				error = EU_ERROR_UNKNOWN;
			}

			if (error != EU_ERROR_NONE) {
				intPtr.free();

				onError(pThis.MakeError(error));
				return;
			}

			EUFS.unlink(signFile);

			onSuccess(intPtr.toNumber());
		} else {
			var _onSuccess = function(fileReaded) {
				try {
					var signsCount; 

					signsCount = pThis.CtxGetSignsCount(
						context, fileReaded.data);

					onSuccess(signsCount);
				} catch (e) {
					onError(e);
				}
			};

			pThis.ReadFile(signFile, _onSuccess, onError);
		}
	},
	CtxGetFileSignerInfo: function(context, signIndex, signFile, 
		onSuccess, onError) {
		var pThis = this;

		if (pThis.isFileSyncAPISupported) {
			if (!EUFS.link(signFile)) {
				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			}

			var pCertInfoExPtr = EUPointer();
			var certArrPtr = EUPointerArray(context.GetContext());
			var error;
			try {
				error = Module.ccall('EUCtxGetFileSignerInfo',
					'number',
					['number', 'number', 'array',
						'number', 'number', 'number'],
					[context.GetContext(), signIndex, 
						UTF8ToCP1251Array(EUFS.getFilePath(signFile)),
						pCertInfoExPtr.ptr, 
						certArrPtr.ptr, certArrPtr.lengthPtr]);
			} catch (e) {
				error = EU_ERROR_UNKNOWN;
			}

			if (error != EU_ERROR_NONE) {
				EUFS.unlink(signFile);
				pCertInfoExPtr.free();
				certArrPtr.free();

				onError(pThis.MakeError(error));
				return;
			}

			EUFS.unlink(signFile);

			var certInfoExPtr, certInfoEx;

			certInfoExPtr = pCertInfoExPtr.toPtr();
			certInfoEx = new EndUserCertificateInfoEx(certInfoExPtr);
			Module._EUCtxFreeCertificateInfoEx(
				context.GetContext()|0, certInfoExPtr);

			onSuccess(new EndUserCertificate(certInfoEx, certArrPtr.toArray()));
		} else {
			var _onSuccess = function(fileReaded) {
				try {
					var signerInfo; 

					signerInfo = pThis.CtxGetSignerInfo(
						context, signIndex, fileReaded.data);

					onSuccess(signerInfo);
				} catch (e) {
					onError(e);
				}
			};

			pThis.ReadFile(signFile, _onSuccess, onError);
		}
	},
	CtxVerifyFile: function(context, signIndex, fileWithSign, 
		file, onSuccess, onError) {
		var pThis = this;

		var internal = (file == null) || (typeof file === 'string');

		if (pThis.isFileSyncAPISupported) {
			var dataFile = (file != null) ?
				file :
				(fileWithSign.name + MakeUID(10));

			if (internal) {
				if (!EUFS.link(dataFile, (file == null))) {
					onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
					return;
				}
			} else {
				if (!EUFS.link(dataFile)) {
					onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
					return;
				}
			}

			if (!EUFS.link(fileWithSign)) {
				EUFS.unlink(dataFile);

				onError(pThis.MakeError(EU_ERROR_JS_READ_FILE));
				return;
			}

			var infoPtr = EUPointerSignerInfo();
			var timeInfo;
			var error;

			try {
				error = Module.ccall('EUCheckFileStruct',
					'number',
					['array'],
					[UTF8ToCP1251Array(EUFS.getFilePath(fileWithSign))]);
				if (error == EU_ERROR_NONE) {
					error = Module.ccall('EUCtxVerifyFile',
						'number',
						['number', 'number', 'array', 'array', 'number'],
						[context.GetContext(), signIndex, 
							UTF8ToCP1251Array(EUFS.getFilePath(fileWithSign)), 
							UTF8ToCP1251Array(EUFS.getFilePath(dataFile)), 
							infoPtr.ptr]);
				}
			} catch (e) {
				error = EU_ERROR_UNKNOWN;
			}

			if (error != EU_ERROR_NONE) {
				EUFS.unlink(fileWithSign);
				EUFS.unlink(dataFile);

				onError(pThis.MakeError(error));
				return;
			}

			var data = (internal && (file != null)) ?
				EUFS.readFileAsUint8Array(dataFile) :
				null;

			EUFS.unlink(fileWithSign);
			EUFS.unlink(dataFile);
			
			try {
				timeInfo = pThis._GetFileSignTimeInfoSync(
					signIndex, fileWithSign);
			} catch (e) {
				onError(e);
				return;
			}

			var info = new EndUserSignInfo(infoPtr.ptr, 
				data, timeInfo);
			infoPtr.free();

			onSuccess(info);
		} else {
			var _onSuccess= function(files) {
				try {
					var info;

					if (internal) {
						info = pThis.CtxVerifyDataInternal(
							context, signIndex, files[0].data);
						if (file == null)
							info.data = null;
					} else {
						info = pThis.CtxVerifyData(
							context, files[0].data, 
							signIndex, files[1].data);
						info.data = null;
					}

					onSuccess(info);
				} catch (e) {
					onError(e);
				}
			};

			var files = [];
			if (!internal)
				files.push(file);
			files.push(fileWithSign);

			pThis.ReadFiles(files, 
				_onSuccess, onError);
		}
	},
	GetTSPByAccessInfo: function(
		hashAlgo, hash, accessInfo, accessInfoPort) {
		this.CheckMaxDataSize(hash);

		var isHashStr = ((typeof hash) == 'string');
		var pPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUGetTSPByAccessInfo',
				'number',
				['number', 
					isHashStr ? 'array' : 'number',
					!isHashStr ? 'array' : 'number', 'number',
					accessInfo ? 'array' : 'number',
					accessInfoPort ? 'array' : 'number',
					'number', 'number'],
				[hashAlgo,
					isHashStr ? StringToCString(hash) : 0, 
					!isHashStr ? hash : 0, 
					!isHashStr ? hash.length : 0, 
					accessInfo ? UTF8ToCP1251Array(accessInfo) : 0,
					accessInfoPort ? UTF8ToCP1251Array(accessInfoPort) : 0,
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		return pPtr.toArray();
	},
	CheckTSP: function(
		tsp, hashAlgo, hash) {
		var error;

		this.CheckMaxDataSize(tsp);

		if (hash) {
			this.CheckMaxDataSize(hash);
			hash = ((typeof hash) == 'string') ?
				this.Base64Decode(hash) : hash;
		}

		try {
			error = Module.ccall('EUCheckTSP',
				'number',
				['array', 'number',
					'number', 'number',
					hash ? 'array' : 'number', 'number'],
				[tsp, tsp.length,
					hashAlgo, 0, 
					hash ? hash : 0, 
					hash ? hash.length : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}
	},
//-----------------------------------------------------------------------------
	IsEnvelopedData: function(enveloped) {
		this.CheckMaxDataSize(enveloped);

		if ((typeof enveloped) == 'string')
			enveloped = this.Base64Decode(enveloped);

		var isEnveloped = false;
		var error;

		try {
			isEnveloped = (Module.ccall('EUIsEnvelopedData',
				'number',
				['array', 'number'],
				[enveloped, enveloped.length]) != EU_FALSE);
			error = EU_ERROR_NONE;
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}

		return isEnveloped;
	},
	EnvelopDataEx: function (recipientCertIssuers, recipientCertSerials, 
		signData, data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var envDataPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var issuers = intArrayFromStrings(recipientCertIssuers);
		var serials = intArrayFromStrings(recipientCertSerials);
		var error;

		try {
			error = Module.ccall('EUEnvelopDataEx',
				'number',
				['array', 'array', 'number', 
					data ? 'array' : 'number', 'number', 
					'number', 'number', 'number'],
				[issuers, serials, IntFromBool(signData),
					(data != null) ? data : 0,
					data != null ? data.length : 0,
					asBase64String ? envDataPtr.ptr : 0,
					!asBase64String ? envDataPtr.ptr : 0,
					!asBase64String ? envDataPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			envDataPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return envDataPtr.toString(true);
		else
			return envDataPtr.toArray();
	},
	DevelopData: function(data) {
		this.CheckMaxDataSize(data);

		var isDataStr = ((typeof data) == 'string');
		var devDataPtr = EUPointerArray();
		var infoPtr = EUPointerSenderInfo();
		var error;

		try {
			error = Module.ccall('EUDevelopData',
				'number',
				[isDataStr ? 'array' : 'number',
					!isDataStr ? 'array' : 'number',
					'number', 'number', 'number', 'number'],
				[isDataStr ? StringToCString(data)  : 0,
					!isDataStr ? data : 0,
					!isDataStr ? data.length : 0,
					devDataPtr.ptr, devDataPtr.lengthPtr, infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			devDataPtr.free();
			infoPtr.free();
			this.RaiseError(error);
		}

		var info = new EndUserSenderInfo(infoPtr.ptr, devDataPtr.toArray());
		devDataPtr.free();

		return info;
	},
	EnvelopDataToRecipientsWithDynamicKey: function(
		recipientCertificates, signData, appendCert, data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var envDataPtr = asBase64String ? 
			EUPointer() : EUPointerArray();

		var recipientCertsArray = 
			new EUArrayFromArrayOfArray(recipientCertificates);
		var error;

		try {
			error = Module.ccall('EUEnvelopDataToRecipientsWithDynamicKey',
				'number',
				['number', 'number', 'number', 'number', 'number', 
					'array', 'number', 'number', 'number', 'number'],
				[recipientCertsArray.count,
					recipientCertsArray.arraysPtr,
					recipientCertsArray.arraysLengthPtr,
					IntFromBool(signData),
					IntFromBool(appendCert),
					data, data.length, 
					asBase64String ? envDataPtr.ptr : 0,
					!asBase64String ? envDataPtr.ptr : 0,
					!asBase64String ? envDataPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			recipientCertsArray.free();
			envDataPtr.free();
			this.RaiseError(error);
		}

		recipientCertsArray.free();

		if (asBase64String)
			return envDataPtr.toString(true);
		else
			return envDataPtr.toArray();
	},
	EnvelopDataRSAEx: function (contentEncAlgoType, 
		recipientCertIssuers, recipientCertSerials, 
		signData, data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var envDataPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var issuers = intArrayFromStrings(recipientCertIssuers);
		var serials = intArrayFromStrings(recipientCertSerials);
		var error;

		try {
			error = Module.ccall('EUEnvelopDataRSAEx',
				'number',
				['number', 'array', 'array', 'number', 
					data ? 'array' : 'number', 'number', 
					'number', 'number', 'number'],
				[contentEncAlgoType, issuers, serials, IntFromBool(signData),
					(data != null) ? data : 0,
					data != null ? data.length : 0,
					asBase64String ? envDataPtr.ptr : 0,
					!asBase64String ? envDataPtr.ptr : 0,
					!asBase64String ? envDataPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			envDataPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return envDataPtr.toString(true);
		else
			return envDataPtr.toArray();
	},
	CtxEnvelopData: function (privateKeyContext,
		recipientCertificates, recipientAppendType,
		signData, appendCert, data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var pPtr = EUPointer(privateKeyContext.GetContext());
		var recipientCertsArray = 
			new EUArrayFromArrayOfArray(recipientCertificates);
		var error;

		try {
			error = Module.ccall('EUCtxEnvelopData',
				'number',
				['number', 'number', 'number', 'number',
					'number', 'number', 'number',
					'array', 'number', 'number', 'number'],
				[privateKeyContext.GetContext(),
					recipientCertsArray.count,
					recipientCertsArray.arraysPtr,
					recipientCertsArray.arraysLengthPtr,
					recipientAppendType, 
					IntFromBool(signData), IntFromBool(appendCert),
					data, data.length, pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			recipientCertsArray.free();
			pPtr.free();
			this.RaiseError(error);
		}

		recipientCertsArray.free();
		
		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxDevelopData: function (privateKeyContext,
		data, senderCert) {
		this.CheckMaxDataSize(data);
		if (senderCert != null)
			this.CheckMaxDataSize(senderCert);

		var isEnvDataStr = ((typeof data) == 'string');
		var devDataPtr = EUPointer(privateKeyContext.GetContext());
		var infoPtr = EUPointerSenderInfo();
		var error;

		try {
			error = Module.ccall('EUCtxDevelopData',
				'number',
				['number', 
					isEnvDataStr ? 'array' : 'number', 
					!isEnvDataStr ? 'array' : 'number', 'number',
					senderCert ? 'array' : 'number', 'number',
					'number', 'number', 'number'],
				[privateKeyContext.GetContext(),
					isEnvDataStr ? StringToCString(data)  : 0,
					!isEnvDataStr ? data : 0,
					!isEnvDataStr ? data.length : 0,
					(senderCert != null) ? senderCert : 0,
					(senderCert != null) ? senderCert.length : 0,
					devDataPtr.ptr, devDataPtr.lengthPtr, infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			devDataPtr.free();
			infoPtr.free();
			this.RaiseError(error);
		}
		
		var info = new EndUserSenderInfo(infoPtr.ptr, devDataPtr.toArray());
		devDataPtr.free();

		return info;
	},
	CtxEnvelopDataWithDynamicKey: function (privateKeyContext,
		recipientCertificates, recipientAppendType,
		signData, appendCert, data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var pPtr = EUPointer(privateKeyContext.GetContext());
		var recipientCertsArray = 
			new EUArrayFromArrayOfArray(recipientCertificates);
		var error;

		try {
			error = Module.ccall('EUCtxEnvelopDataWithDynamicKey',
				'number',
				['number', 'number', 'number', 'number',
					'number', 'number', 'number',
					'array', 'number', 'number', 'number'],
				[privateKeyContext.GetContext(),
					recipientCertsArray.count,
					recipientCertsArray.arraysPtr,
					recipientCertsArray.arraysLengthPtr,
					recipientAppendType, 
					IntFromBool(signData), IntFromBool(appendCert),
					data, data.length, pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			recipientCertsArray.free();
			pPtr.free();
			this.RaiseError(error);
		}

		recipientCertsArray.free();
		
		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	CtxGetSenderInfo: function(context, data, recipientCert) {
		this.CheckMaxDataSize(data);

		if ((typeof data) == 'string')
			data = this.Base64Decode(data);

		var isDynamicKeyPtr = EUPointerInt();
		var pCertInfoExPtr = EUPointer();
		var certArrPtr = EUPointerArray(context.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxGetSenderInfo',
				'number',
				['number', 'array', 'number', 'array', 'number',
					'number', 'number', 'number', 'number'],
				[context.GetContext(), data, data.length,
					recipientCert, recipientCert.length,
					isDynamicKeyPtr.ptr, pCertInfoExPtr.ptr,
					certArrPtr.ptr, certArrPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			isDynamicKeyPtr.free();
			pCertInfoExPtr.free();
			certArrPtr.free();

			this.RaiseError(error);
		}

		var certInfoExPtr, certInfoEx;

		certInfoExPtr = pCertInfoExPtr.toPtr();
		certInfoEx = new EndUserCertificateInfoEx(certInfoExPtr);
		Module._EUCtxFreeCertificateInfoEx(
			context.GetContext()|0, certInfoExPtr);

		return EndUserSenderInfoEx(
			isDynamicKeyPtr.toBoolean(),
			certInfoEx, certArrPtr.toArray());
	},
	CtxGetRecipientsCount: function(context, envelopedData) {
		this.CheckMaxDataSize(envelopedData);

		if ((typeof envelopedData) == 'string')
			envelopedData = this.Base64Decode(envelopedData);

		var intPtr = EUPointerDWORD();
		var error;

		try {
			error = Module.ccall('EUCtxGetRecipientsCount',
				'number',
				['number', 'array', 'number', 'number'],
				[context.GetContext(), envelopedData,
					envelopedData.length, intPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			intPtr.free();

			this.RaiseError(error);
		}

		return intPtr.toNumber();
	},
	CtxGetRecipientInfo: function(context, 
		recipientIndex, envelopedData) {
		this.CheckMaxDataSize(envelopedData);

		if ((typeof envelopedData) == 'string')
			envelopedData = this.Base64Decode(envelopedData);

		var infoTypePtr = EUPointerDWORD();
		var pIssuerPtr = EUPointer(context.GetContext());
		var pSerialPtr = EUPointer(context.GetContext());
		var pPublicKeyIDPtr = EUPointer(context.GetContext());
		var error;

		try {
			error = Module.ccall('EUCtxGetRecipientInfo',
				'number',
				['number', 'number', 'array', 'number',
					'number', 'number', 'number', 'number'],
				[context.GetContext(), recipientIndex,
					envelopedData, envelopedData.length,
					infoTypePtr.ptr,
					pIssuerPtr.ptr, pSerialPtr.ptr,
					pPublicKeyIDPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			infoTypePtr.free();
			pIssuerPtr.free();
			pSerialPtr.free();
			pPublicKeyIDPtr.free();

			this.RaiseError(error);
		}

		return EndUserRecipientInfo(
			infoTypePtr.toNumber(),
			pIssuerPtr.toString(), pSerialPtr.toString(),
			pPublicKeyIDPtr.toString());
	},
//-----------------------------------------------------------------------------
	ClientSessionCreateStep1: function(expireTime) {
		var pPtr = EUPointer();
		var error;

		var dataPtr = EUPointerArray();

		try {
			error = Module.ccall('EUClientSessionCreateStep1',
				'number',
				['number', 'number', 'number', 'number'],
				[expireTime, pPtr.ptr, dataPtr.ptr, dataPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			dataPtr.free();
			this.RaiseError(error);
		}

		return new EndUserSession(pPtr.toPtr(),
			dataPtr.toArray());
	},
	ServerSessionCreateStep1: function(expireTime, clientData) {
		var pPtr = EUPointer();
		var error;

		var dataPtr = EUPointerArray();

		try {
			error = Module.ccall('EUServerSessionCreateStep1',
				'number',
				['number', 'array', 'number', 
					'number', 'number', 'number'],
				[expireTime, clientData, clientData.length, 
					pPtr.ptr, dataPtr.ptr, dataPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			dataPtr.free();
			this.RaiseError(error);
		}

		return new EndUserSession(pPtr.toPtr(),
			dataPtr.toArray());
	},
	ClientSessionCreateStep2: function(session, serverData) {
		var error;

		var dataPtr = EUPointerArray();

		try {
			error = Module.ccall('EUClientSessionCreateStep2',
				'number',
				['number', 'array', 'number', 
					'number', 'number'],
				[session.GetHandle()|0, serverData, serverData.length, 
					dataPtr.ptr, dataPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			dataPtr.free();
			this.RaiseError(error);
		}

		session.SetData(dataPtr.toArray());
	},
	ServerSessionCreateStep2: function(session, clientData) {
		var error;

		try {
			error = Module.ccall('EUServerSessionCreateStep2',
				'number',
				['number', 'array', 'number'],
				[session.GetHandle()|0, 
					clientData, clientData.length]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}
	},
	SessionClose: function(session) {
		var error = EU_ERROR_NONE;

		try {
			Module.ccall('EUSessionDestroy',
				'number',
				['number'],
				[session.GetHandle()|0]);
			error = EU_ERROR_NONE;
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}
	},
	SessionIsInitialized: function(session) {
		var isInitialized;
		var error = EU_ERROR_NONE;

		try {
			isInitialized = Module.ccall('EUSessionIsInitialized',
				'number',
				['number'],
				[session.GetHandle()|0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}
		
		return (isInitialized != EU_FALSE);
	},
	SessionCheckCertificates: function(session) {
		var error = EU_ERROR_NONE;

		try {
			error = Module.ccall('EUSessionCheckCertificates',
				'number',
				['number'],
				[session.GetHandle()|0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}
		
		return true;
	},
	SessionGetPeerCertificateInfo: function(session) {
		var infoPtr = EUPointerCertificateInfo();
		var error;

		try {
			error = Module.ccall('EUSessionGetPeerCertificateInfo',
				'number',
				['number', 'number'],
				[session.GetHandle()|0, infoPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			infoPtr.free();
			this.RaiseError(error);
		}

		var info = new EndUserCertificateInfo(infoPtr.ptr);
		infoPtr.free();

		return info;
	},
	SessionSave: function(session) {
		var error;

		var dataPtr = EUPointerArray();

		try {
			error = Module.ccall('EUSessionSave',
				'number',
				['number', 'number', 'number'],
				[session.GetHandle()|0, 
					dataPtr.ptr, dataPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			dataPtr.free();
			this.RaiseError(error);
		}
		
		return dataPtr.toArray();
	},
	SessionLoad: function(sessionData) {
		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUSessionLoad',
				'number',
				['array', 'number', 'number'],
				[sessionData, sessionData.length, pPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		return new EndUserSession(pPtr.toPtr(), null);
	},
	ClientDynamicKeySessionCreate: function(
		expireTime, serverCertIssuer, serverCertSerial) {
		var isCertData = arguments.length == 2;

		var pPtr = EUPointer();
		var error;

		var dataPtr = EUPointerArray();

		try {
			error = Module.ccall('EUClientDynamicKeySessionCreate',
				'number',
				['number',
					isCertData ? 'number' : 'array', 
					isCertData ? 'number' : 'array', 
					isCertData ? 'array': 'number', 'number',
					'number', 'number', 'number'],
				[expireTime, 
					isCertData ? 0 : UTF8ToCP1251Array(serverCertIssuer), 
					isCertData ? 0 : UTF8ToCP1251Array(serverCertSerial),
					isCertData ? serverCertIssuer : 0,
					isCertData ? serverCertIssuer.length : 0,
					pPtr.ptr, dataPtr.ptr, dataPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			dataPtr.free();
			this.RaiseError(error);
		}

		return new EndUserSession(pPtr.toPtr(),
			dataPtr.toArray());
	},
	ServerDynamicKeySessionCreate: function(
		expireTime, clientData) {
		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUServerDynamicKeySessionCreate',
				'number',
				['number', 'array', 'number', 
					'number'],
				[expireTime, clientData, clientData.length, 
					pPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		return new EndUserSession(pPtr.toPtr(), null);
	},
	ClientDynamicKeySessionLoad: function(sessionData) {
		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUClientDynamicKeySessionLoad',
				'number',
				['array', 'number', 'number'],
				[sessionData, sessionData.length, pPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		return new EndUserSession(pPtr.toPtr(), null);
	},
	SessionEncrypt: function(session, data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var pPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUSessionEncrypt',
				'number',
				['number', 'array', 'number', 'number', 'number'],
				[session.GetHandle()|0,
					data, data.length, pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	SessionDecrypt: function(session, encryptedData) {
		if ((typeof encryptedData) == 'string')
			encryptedData = this.Base64Decode(encryptedData);

		this.CheckMaxDataSize(encryptedData);

		var pPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUSessionDecrypt',
				'number',
				['number', 'array', 'number', 'number', 'number'],
				[session.GetHandle()|0,
					encryptedData, encryptedData.length, 
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		return pPtr.toArray();
	},
	SessionEncryptContinue: function(session, data, asBase64String) {
		if ((typeof data) == 'string')
			data = this.StringToArray(data);

		this.CheckMaxDataSize(data);

		var pPtr = EUPointerStaticArray(data);
		var error;

		try {
			error = Module.ccall('EUSessionEncryptContinue',
				'number',
				['number', 'number', 'number'],
				[session.GetHandle()|0, pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return this.Base64Encode(pPtr.toArray());
		else 
			return pPtr.toArray();
	},
	SessionDecryptContinue: function(session, encryptedData) {
		if ((typeof encryptedData) == 'string')
			encryptedData = this.Base64Decode(encryptedData);

		this.CheckMaxDataSize(encryptedData);

		var pPtr = EUPointerStaticArray(encryptedData);
		var error;

		try {
			error = Module.ccall('EUSessionDecryptContinue',
				'number',
				['number', 'number', 'number'],
				[session.GetHandle()|0,
					pPtr.ptr, pPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		return pPtr.toArray();
	},
//-----------------------------------------------------------------------------
	CtxCreate: function() {
		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUCtxCreate',
				'number',
				['number'],
				[pPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}
		
		var context = new EndUserContext(pPtr.toPtr());

		return context;
	},
	CtxFree: function(context) {
		try {
			Module._EUCtxFree(context.GetContext()|0);
		} catch (e) {
		}
	},
	CtxSetParameter: function(context, name, value) {
		var error;
		var intPtr = EUPointerBool();
		if (typeof value != 'boolean') {
			this.RaiseError(EU_ERROR_BAD_PARAMETER);
		}
		
		try {
			Module.setValue(intPtr.ptr,
				IntFromBool(value) | 0, "i32");

			error = Module.ccall('EUCtxSetParameter',
				'number',
				['number', 'array', 'number', 'number'],
				[context.GetContext()|0, 
					UTF8ToCP1251Array(name), intPtr.ptr, EU_BOOL_SIZE]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
			intPtr.free();
		}

		if (error != EU_ERROR_NONE) {
			this.RaiseError(error);
		}

		intPtr.free();
	},
//-----------------------------------------------------------------------------
	ProtectDataByPassword: function(data, password, asBase64String) {
		if ((typeof data) == 'string')
			data = UTF8ToCP1251Array(data);

		this.CheckMaxDataSize(data);

		var protDataPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUProtectDataByPassword',
				'number',
				['array', 'number', 
					password ? 'array' : 'number',
					'number', 'number', 'number'],
				[data, data.length, 
					(password != null) ? 
						UTF8ToCP1251Array(password) : 0,
					asBase64String ? protDataPtr.ptr : 0,
					!asBase64String ? protDataPtr.ptr : 0,
					!asBase64String ? protDataPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			protDataPtr.free();
			this.RaiseError(error);
		}

		if (asBase64String)
			return protDataPtr.toString();
		else
			return protDataPtr.toArray();
	},
	UnprotectDataByPassword: function(data, password, asString) {
		this.CheckMaxDataSize(data);

		var isDataStr = ((typeof data) == 'string');
		var unprotDataPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUUnprotectDataByPassword',
				'number',
				[isDataStr ? 'array' : 'number',
					!isDataStr ? 'array' : 'number', 'number',
					password ? 'array' : 'number',
					'number', 'number'],
				[isDataStr ? StringToCString(data) : 0,
					!isDataStr ? data : 0,
					!isDataStr ? data.length : 0,
					(password != null) ? 
						UTF8ToCP1251Array(password) : 0,
					unprotDataPtr.ptr, unprotDataPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			unprotDataPtr.free();
			this.RaiseError(error);
		}

		if (asString) {
			return unprotDataPtr.toString();
		} else {
			return unprotDataPtr.toArray();
		}
	},
//-----------------------------------------------------------------------------
	QRCodeEncode: function(data) {
		var arrPtr = null;
		var arrLenPtr = null;
		var imgArray = null;
		var error = EU_ERROR_NONE;

		this.CheckMaxDataSize(data);

		var _free = function() {
			try {
				if (arrPtr != null)
					Module._free(arrPtr);

				if (arrLenPtr != null)
					Module._free(arrLenPtr);
			} catch (e) {
			}
		};

		try {
			arrPtr = Module._malloc(4);
			arrLenPtr = Module._malloc(4);

			Module.setValue(arrPtr, 0);
			Module.setValue(arrLenPtr, 0);

			var isSuccess = Module.ccall('QRCodeEncode',
				'number',
				['array', 'number', 'number', 'number'],
				[data, data.length, arrPtr, arrLenPtr]);
			if (isSuccess) {
				var imgData = Module.getValue(arrPtr, "i8*");
				var imgDataLength = Module.getValue(arrLenPtr, "i32");
				var imgBuffer = new ArrayBuffer(imgDataLength);

				imgArray = new Uint8Array(imgBuffer);
				imgArray.set(new Uint8Array(
					Module.HEAPU8.buffer, imgData, imgDataLength));

				Module._QRCodeFreeMemory(imgData);
			} else {
				error = EU_ERROR_BAD_PARAMETER;
			}
			
			_free();
		} catch (e) {
			_free();
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE)
			this.RaiseError(error);

		return imgArray;
	},
//-----------------------------------------------------------------------------
	AppendTransportHeader: function(caType, fileName, 
		clientEMail, clientCert, data) {
		this.CheckMaxDataSize(data);

		var resultDataPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUAppendTransportHeader',
				'number',
				['array', 'array', 'array', 
					'array', 'number', 'array', 'number', 
					'number', 'number'],
				[UTF8ToCP1251Array(caType),
					UTF8ToCP1251Array(fileName),
					UTF8ToCP1251Array(clientEMail),
					clientCert, clientCert.length, 
					data, data.length,
					resultDataPtr.ptr, resultDataPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			resultDataPtr.free();
			this.RaiseError(error);
		}

		return resultDataPtr.toArray();
	},
//-----------------------------------------------------------------------------
	ParseTransportHeader: function(data) {
		if ((typeof data) == 'string')
			data = this.Base64Decode(data);

		this.CheckMaxDataSize(data);

		var intPtr = EUPointerDWORD();
		var resultDataPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUParseTransportHeader',
				'number',
				['array', 'number', 
					'number', 'number', 'number'],
				[data, data.length, intPtr.ptr,
					resultDataPtr.ptr, resultDataPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			intPtr.free();
			resultDataPtr.free();
			this.RaiseError(error);
		}

		return new EndUserTransportHeader(
			intPtr.toNumber(), resultDataPtr.toArray());
	},
//-----------------------------------------------------------------------------
	AppendCryptoHeader: function(caType, headerType, data) {
		this.CheckMaxDataSize(data);

		var resultDataPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUAppendCryptoHeader',
				'number',
				['array', 'number', 
					'array', 'number',
					'number', 'number'],
				[UTF8ToCP1251Array(caType), 
					headerType, data, data.length,
					resultDataPtr.ptr, resultDataPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			resultDataPtr.free();
			this.RaiseError(error);
		}

		return resultDataPtr.toArray();
	},
//-----------------------------------------------------------------------------
	ParseCryptoHeader: function(data) {
		if ((typeof data) == 'string')
			data = this.Base64Decode(data);

		this.CheckMaxDataSize(data);

		var caTypePtr = EUPointerMemory(EU_HEADER_MAX_CA_TYPE_SIZE + 1);
		var headerTypePtr = EUPointerDWORD();
		var headerSizePtr = EUPointerDWORD();
		var resultDataPtr = EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUParseCryptoHeader',
				'number',
				['array', 'number',
					'number', 'number', 'number', 
					'number', 'number'],
				[data, data.length, 
					caTypePtr.ptr, headerTypePtr.ptr, headerSizePtr.ptr,
					resultDataPtr.ptr, resultDataPtr.lengthPtr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			caTypePtr.free();
			headerTypePtr.free();
			headerSizePtr.free();
			resultDataPtr.free();
			this.RaiseError(error);
		}

		var caType = CP1251PointerToUTF8(caTypePtr.ptr);
		caTypePtr.free();
		
		return new EndUserCryptoHeader(
			caType, headerTypePtr.toNumber(), 
			headerSizePtr.toNumber(),
			resultDataPtr.toArray());
	},
//-----------------------------------------------------------------------------
	SServerClientSignHashAsync: function(
		serverAddress, serverPort, clientID, originatorDescription,
		hashDescription, hash, signAlgorithmName) {
		var isPort = serverPort != null && serverPort != "";
		var isHashStr = ((typeof hash) == 'string');
		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUSServerClientSignHashAsync',
				'number',
				['array', 
					isPort ? 'array' : 'number', 'array', 
					originatorDescription ? 'array' : 'number', 
					'array', 
					isHashStr ? 'array' : 'number',
					(!isHashStr) ? 'array' : 'number',
						'number', 'array', 'number'],
				[UTF8ToCP1251Array(serverAddress),
					isPort ? UTF8ToCP1251Array(serverPort) : 0,
					UTF8ToCP1251Array(clientID),
					originatorDescription ? UTF8ToCP1251Array(originatorDescription) : 0,
					UTF8ToCP1251Array(hashDescription),
					isHashStr ? StringToCString(hash) : 0,
					!isHashStr ? hash : 0,
					!isHashStr ? hash.length : 0,
					UTF8ToCP1251Array(signAlgorithmName),
					pPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		return pPtr.toString(true);
	},
	SServerClientCheckSignHashStatus: function(
		serverAddress, serverPort, clientID, 
		operationID, asBase64String) {
		var isPort = serverPort != null && serverPort != "";
		var pPtr = asBase64String ? 
			EUPointer() : EUPointerArray();
		var error;

		try {
			error = Module.ccall('EUSServerClientCheckSignHashStatus',
				'number',
				['array', 
					isPort ? 'array' : 'number', 'array', 'array', 
					'number', 'number', 'number'],
				[UTF8ToCP1251Array(serverAddress),
					isPort ? UTF8ToCP1251Array(serverPort) : 0,
					UTF8ToCP1251Array(clientID),
					UTF8ToCP1251Array(operationID),
					asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.ptr : 0,
					!asBase64String ? pPtr.lengthPtr : 0]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		var sign = asBase64String ? 
			pPtr.toString(true) : pPtr.toArray();
		return sign && (sign.length > 0) ? sign : null;
	},
	SServerClientGeneratePrivateKeyAsync: function(
		serverAddress, serverPort, clientID, 
		originatorDescription, privateKeyDescription, 
		uaAlgorithmName, uaDSKeyLength, useDSKeyAsKEP, uaKEPKeyLength,
		internationalAlgorithmName, internationalKeyLength) {
		var isPort = serverPort != null && serverPort != "";
		var isUAAlgorithmName = 
			((typeof uaAlgorithmName) == 'string');
		var isIntAlgorithmName = 
			((typeof internationalAlgorithmName) == 'string');
		var pPtr = EUPointer();
		var error;

		try {
			error = Module.ccall('EUSServerClientGeneratePrivateKeyAsync',
				'number',
				['array', 
					isPort ? 'array' : 'number', 'array', 
					originatorDescription ? 'array' : 'number',
					'array', 
					isUAAlgorithmName ? 'array' : 'number',
					'number', 'number', 'number',
					isIntAlgorithmName ? 'array' : 'number',
					'number', 'number'],
				[UTF8ToCP1251Array(serverAddress),
					isPort ? UTF8ToCP1251Array(serverPort) : 0,
					UTF8ToCP1251Array(clientID),
					originatorDescription ? UTF8ToCP1251Array(originatorDescription) : 0,
					UTF8ToCP1251Array(privateKeyDescription),
					isUAAlgorithmName ? 
						UTF8ToCP1251Array(uaAlgorithmName) : 0,
					uaDSKeyLength, 
					useDSKeyAsKEP ? 1 : 0,
					uaKEPKeyLength, 
					isIntAlgorithmName ? 
						UTF8ToCP1251Array(internationalAlgorithmName) : 0,
					internationalKeyLength,
					pPtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}
		
		if (error != EU_ERROR_NONE) {
			pPtr.free();
			this.RaiseError(error);
		}

		return pPtr.toString(true);
	},
	SServerClientCheckGeneratePrivateKeyStatus: function(
		serverAddress, serverPort, clientID, operationID) {
		var isPort = serverPort != null && serverPort != "";
		var uaReqPtr = EUPointerArray();
		var uaReqNamePtr = EUPointerMemory(EU_PATH_MAX_LENGTH);
		var uaKEPReqPtr = EUPointerArray();
		var uaKEPReqNamePtr = EUPointerMemory(EU_PATH_MAX_LENGTH);
		var intReqPtr = EUPointerArray();
		var intReqNamePtr = EUPointerMemory(EU_PATH_MAX_LENGTH);
		var error;

		var _free = function() {
			uaReqPtr.free();
			uaReqNamePtr.free();
			uaKEPReqPtr.free();
			uaKEPReqNamePtr.free();
			intReqPtr.free();
			intReqNamePtr.free();
		};

		try {
			error = Module.ccall(
				'EUSServerClientCheckGeneratePrivateKeyStatus',
				'number',
				['array', 
					isPort ? 'array' : 'number', 
					'array', 'array', 
					'number', 'number', 'number',
					'number', 'number', 'number',
					'number', 'number', 'number'],
				[UTF8ToCP1251Array(serverAddress),
					isPort ? UTF8ToCP1251Array(serverPort) : 0,
					UTF8ToCP1251Array(clientID),
					UTF8ToCP1251Array(operationID),
					uaReqPtr.ptr, uaReqPtr.lengthPtr,
					uaReqNamePtr.ptr, 
					uaKEPReqPtr.ptr, uaKEPReqPtr.lengthPtr, 
					uaKEPReqNamePtr.ptr,
					intReqPtr.ptr, intReqPtr.lengthPtr, 
					intReqNamePtr.ptr]);
		} catch (e) {
			error = EU_ERROR_UNKNOWN;
		}

		if (error != EU_ERROR_NONE) {
			_free();
			this.RaiseError(error);
		}

		var _toString = function(strPtr) {
			var str = CP1251PointerToUTF8(strPtr);
			var lastInd = str.lastIndexOf("/");
			if (lastInd < 0)
				return str;

			return str.substring(lastInd + 1, str.length);
		};
		
		var _toArray = function(arrPtr) {
			var arr = arrPtr.toArray();
			return (arr && (arr.length > 0)) ? arr : null;
		};

		var uaReq = _toArray(uaReqPtr);
		var uaReqName = _toString(uaReqNamePtr.ptr);
		var uaKEPReq = _toArray(uaKEPReqPtr);
		var uaKEPReqName = _toString(uaKEPReqNamePtr.ptr);
		var intReq = _toArray(intReqPtr);
		var intReqName = _toString(intReqNamePtr.ptr);

		if ((uaReq == null) && 
			(uaKEPReq == null) && 
			(intReq == null)) {
			return null;
		}

		var euPrivateKey = EndUserPrivateKey(
			null, null, uaReq, uaReqName, 
			uaKEPReq, uaKEPReqName, 
			intReq, intReqName);

		_free();

		return euPrivateKey;
	}
});

// SD DBG added
export var EUSignAlias = EUSignCP;

//=============================================================================
